!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? t(exports)
    : 'function' == typeof define && define.amd
      ? define(['exports'], t)
      : t(((e = 'undefined' != typeof globalThis ? globalThis : e || self).window = e.window || {}));
})(this, function (e) {
  'use strict';
  let t,
    n,
    o,
    i,
    r,
    l = (e) =>
      'object' == typeof e &&
      null !== e &&
      e.constructor === Object &&
      '[object Object]' === Object.prototype.toString.call(e),
    a = (e) => 'string' == typeof e,
    s = (e) => e && null !== e && e instanceof Element && 'nodeType' in e,
    c = function (e) {
      var t = new DOMParser().parseFromString(e, 'text/html').body;
      if (t.childElementCount > 1) {
        for (var n = document.createElement('div'); t.firstChild; ) n.appendChild(t.firstChild);
        return n;
      }
      let o = t.firstChild;
      if (o && !(o instanceof HTMLElement)) {
        var n = document.createElement('div');
        return (n.appendChild(o), n);
      }
      return o;
    },
    u = function (e) {
      if (!(e && e instanceof Element && e.offsetParent)) return !1;
      let t = !1,
        n = !1;
      if (e.scrollWidth > e.clientWidth) {
        let n = window.getComputedStyle(e).overflowX,
          o = -1 !== n.indexOf('hidden'),
          i = -1 !== n.indexOf('clip'),
          r = -1 !== n.indexOf('visible');
        t = !o && !i && !r;
      }
      if (e.scrollHeight > e.clientHeight) {
        let t = window.getComputedStyle(e).overflowY,
          o = -1 !== t.indexOf('hidden'),
          i = -1 !== t.indexOf('clip'),
          r = -1 !== t.indexOf('visible');
        n = !o && !i && !r;
      }
      return t || n;
    },
    d = function (e, t) {
      return !e || e === document.body || (t && e === t) ? null : u(e) ? e : d(e.parentElement, t);
    },
    f = (e = !0, t = '--f-scrollbar-compensate', n = '--f-body-margin', o = 'hide-scrollbar') => {
      let i = document,
        r = i.body,
        l = i.documentElement;
      if (e) {
        if (r.classList.contains(o)) return;
        let e = window.innerWidth - l.getBoundingClientRect().width;
        (e < 0 && (e = 0), l.style.setProperty(t, `${e}px`));
        let i = parseFloat(window.getComputedStyle(r).marginRight);
        (i && r.style.setProperty(n, `${i}px`), r.classList.add(o));
      } else (r.classList.remove(o), r.style.setProperty(n, ''), i.documentElement.style.setProperty(t, ''));
    },
    g = (e, ...t) => {
      let n = t.length;
      for (let o = 0; o < n; o++)
        Object.entries(t[o] || {}).forEach(([t, n]) => {
          let o = Array.isArray(n) ? [] : {};
          (e[t] || Object.assign(e, { [t]: o }),
            l(n)
              ? Object.assign(e[t], g(e[t], n))
              : Array.isArray(n)
                ? Object.assign(e, { [t]: [...n] })
                : Object.assign(e, { [t]: n }));
        });
      return e;
    };
  function m() {
    return !!('undefined' != typeof window && window.document && window.document.createElement);
  }
  let p = function (e = 0, t = 0, n = 0) {
      return Math.max(Math.min(t, n), e);
    },
    h = function (e = 0, t = 0, n = 0, o = 0, i = 0, r = !1) {
      let l = ((e - t) / (n - t)) * (i - o) + o;
      return r ? (o < i ? p(o, l, i) : p(i, l, o)) : l;
    },
    y = (e, t = '') => {
      e &&
        e.classList &&
        t.split(' ').forEach((t) => {
          t && e.classList.add(t);
        });
    },
    v = (e, t = '') => {
      e &&
        e.classList &&
        t.split(' ').forEach((t) => {
          t && e.classList.remove(t);
        });
    },
    b = (e, t = '', n) => {
      e &&
        e.classList &&
        t.split(' ').forEach((t) => {
          t && e.classList.toggle(t, n || !1);
        });
    };
  function E(e) {
    return l(e) || Array.isArray(e);
  }
  function w(e, t) {
    let n = Object.keys(e),
      o = Object.keys(t);
    return (
      n.length === o.length &&
      n.every((n) => {
        let o = e[n],
          i = t[n];
        return 'function' == typeof o ? `${o}` == `${i}` : E(o) && E(i) ? w(o, i) : o === i;
      })
    );
  }
  let x = (1 / 60) * 3e3,
    M = function (e) {
      for (let t of F) t.getState() === L.Running && t.tick(D ? e - D : 0);
      ((D = e), (H = window.requestAnimationFrame(M)));
    },
    L =
      (((S = {})[(S.Initializing = 0)] = 'Initializing'),
      (S[(S.Running = 1)] = 'Running'),
      (S[(S.Paused = 2)] = 'Paused'),
      (S[(S.Completed = 3)] = 'Completed'),
      (S[(S.Destroyed = 4)] = 'Destroyed'),
      S);
  var S,
    T,
    P,
    A,
    R,
    C,
    O,
    I,
    z,
    k,
    _ = (((T = _ || {})[(T.Spring = 0)] = 'Spring'), (T[(T.Ease = 1)] = 'Ease'), T);
  let $ = (((P = {})[(P.Loop = 0)] = 'Loop'), (P[(P.Reverse = 1)] = 'Reverse'), P),
    F = new Set(),
    H = null,
    D = 0;
  function V() {
    let e = L.Initializing,
      t = _.Ease,
      n = 0,
      o = 0,
      i = V.Easings.Linear,
      r = 500,
      l = 0,
      a = 0,
      s = 0,
      c = 0,
      u = 1 / 0,
      d = 0.01,
      f = 0.01,
      g = !1,
      m = {},
      h = null,
      y = {},
      v = {},
      b = {},
      E = 0,
      S = 0,
      T = $.Loop,
      P = V.Easings.Linear,
      A = new Map();
    function R(e, ...t) {
      for (let n of A.get(e) || []) n(...t);
    }
    function C(e) {
      return (
        (o = 0),
        e
          ? (h = setTimeout(() => {
              O();
            }, e))
          : O(),
        z
      );
    }
    function O() {
      ((e = L.Running), R('start', y, v));
    }
    function I() {
      if (((e = L.Completed), (b = {}), R('end', y), e === L.Completed))
        if (n < E) {
          if ((n++, T === $.Reverse)) {
            let e = { ...m };
            ((m = { ...v }), (v = e));
          }
          C(S);
        } else n = 0;
      return z;
    }
    let z = {
      getState: function () {
        return e;
      },
      easing: function (e) {
        return ((i = e), (t = _.Ease), (b = {}), z);
      },
      duration: function (e) {
        return ((r = e), z);
      },
      spring: function (e = {}) {
        t = _.Spring;
        let {
          velocity: n,
          mass: o,
          tension: i,
          friction: r,
          restDelta: m,
          restSpeed: p,
          maxSpeed: h,
          clamp: y,
        } = {
          velocity: 0,
          mass: 1,
          tension: 170,
          friction: 26,
          restDelta: 0.1,
          restSpeed: 0.1,
          maxSpeed: 1 / 0,
          clamp: !0,
          ...e,
        };
        return ((l = n), (a = o), (s = i), (c = r), (f = m), (d = p), (u = h), (g = y), (b = {}), z);
      },
      isRunning: function () {
        return e === L.Running;
      },
      isSpring: function () {
        return t === _.Spring;
      },
      from: function (e) {
        return ((y = { ...e }), z);
      },
      to: function (e) {
        return ((v = e), z);
      },
      repeat: function (e, t = 0, n = $.Loop, o) {
        return ((E = e), (S = t), (T = n), (P = o || i), z);
      },
      on: function (e, t) {
        return (A.set(e, [...(A.get(e) || []), t]), z);
      },
      off: function (e, t) {
        return (
          A.has(e) &&
            A.set(
              e,
              A.get(e).filter((e) => e !== t),
            ),
          z
        );
      },
      start: function (t) {
        return (
          w(y, v) ||
            ((e = L.Initializing), (m = { ...y }), F.add(this), H || (H = window.requestAnimationFrame(M)), C(t)),
          z
        );
      },
      pause: function () {
        return (h && (clearTimeout(h), (h = null)), e === L.Running && ((e = L.Paused), R('pause', y)), z);
      },
      end: I,
      tick: function (n) {
        (n > x && (n = x), (o += n));
        let h = 0,
          E = !1;
        if (e !== L.Running) return z;
        if (t === _.Ease) {
          E = 1 === (h = p(0, o / r, 1));
          let e = T === $.Reverse ? P : i;
          for (let t in y) y[t] = m[t] + (v[t] - m[t]) * e(h);
        }
        if (t === _.Spring) {
          let e = 0.001 * n,
            t = 0;
          for (let n in y) {
            let o = v[n],
              i = y[n];
            if (!('number' == typeof o && !isNaN(o)) || !('number' == typeof i && !isNaN(i))) continue;
            if (Math.abs(o - i) <= f) {
              ((y[n] = o), (b[n] = 0));
              continue;
            }
            b[n] ||
              ('object' == typeof l && 'number' == typeof l[n]
                ? (b[n] = l[n])
                : 'number' == typeof l
                  ? (b[n] = l)
                  : (b[n] = 0));
            let r = b[n],
              m = (r = p(-1 * Math.abs(u), r, Math.abs(u))) * a * c,
              h = Math.abs(o - i) * s;
            ((r += (((i > o ? -1 : 1) * h - m) / a) * e), (i += r * e));
            let E = y[n] > o ? i < o : i > o,
              w = Math.abs(r) < d && Math.abs(o - i) <= f;
            (g && E && (w = !0), w ? ((i = o), (r = 0)) : t++, (y[n] = i), (b[n] = r));
          }
          E = !t;
        }
        let M = { ...v };
        return (R('step', y, m, v, h), E && e === L.Running && w(v, M) && ((e = L.Completed), I()), z);
      },
      getStartValues: function () {
        return m;
      },
      getCurrentValues: function () {
        return y;
      },
      getCurrentVelocities: function () {
        return b;
      },
      getEndValues: function () {
        return v;
      },
      destroy: function () {
        ((e = L.Destroyed), h && (clearTimeout(h), (h = null)), (m = y = v = {}), F.delete(this));
      },
    };
    return z;
  }
  function j(e) {
    return 'undefined' != typeof TouchEvent && e instanceof TouchEvent;
  }
  function q(e, t) {
    let n = [];
    for (let o of j(e) ? e[t] : e instanceof MouseEvent && ('changedTouches' === t || 'mouseup' !== e.type) ? [e] : [])
      n.push({ x: o.clientX, y: o.clientY, ts: Date.now() });
    return n;
  }
  function N(e) {
    return q(e, 'touches');
  }
  function B(e) {
    return q(e, 'targetTouches');
  }
  function W(e) {
    return q(e, 'changedTouches');
  }
  function Z(e) {
    let t = e[0],
      n = e[1] || t;
    return { x: (t.x + n.x) / 2, y: (t.y + n.y) / 2, ts: n.ts };
  }
  function G(e) {
    let t = e[0],
      n = e[1] || e[0];
    return t && n ? -1 * Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y)) : 0;
  }
  ((V.destroy = () => {
    for (let e of F) e.destroy();
    H && (cancelAnimationFrame(H), (H = null));
  }),
    (V.Easings = {
      Linear: function (e) {
        return e;
      },
      EaseIn: function (e) {
        return 0 === e ? 0 : Math.pow(2, 10 * e - 10);
      },
      EaseOut: function (e) {
        return 1 === e ? 1 : 1 - Math.pow(2, -10 * e);
      },
      EaseInOut: function (e) {
        return 0 === e ? 0 : 1 === e ? 1 : e < 0.5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2;
      },
    }));
  let X = (e) => {
      e.cancelable && e.preventDefault();
    },
    Y = { passive: !1 },
    U = {
      panThreshold: 5,
      swipeThreshold: 3,
      ignore: ['textarea', 'input', 'select', '[contenteditable]', '[data-selectable]', '[data-draggable]'],
    },
    K = !1,
    J = !0,
    Q = (e, t) => {
      let n,
        o,
        i,
        r = { ...U, ...t },
        l = [],
        a = [],
        s = [],
        c = !1,
        u = !1,
        d = !1,
        f = !1,
        g = 0,
        m = 0,
        p = 0,
        h = 0,
        y = 0,
        v = 0,
        b = 0,
        E = 0,
        w = 0,
        x = [],
        M = 0,
        L = 0,
        S = new Map();
      function T(e) {
        let t = G(a),
          r = G(s),
          d = Math.abs(b) > Math.abs(E) ? b : E,
          f = {
            srcEvent: i,
            isPanRecognized: c,
            isSwipeRecognized: u,
            firstTouch: l,
            previousTouch: s,
            currentTouch: a,
            deltaX: p,
            deltaY: h,
            offsetX: y,
            offsetY: v,
            velocityX: b,
            velocityY: E,
            velocity: d,
            angle: w,
            axis: o,
            scale: t && r ? t / r : 0,
            center: n,
          };
        for (let t of S.get(e) || []) t(f);
      }
      function P(e) {
        let t = e.target,
          n = e.composedPath()[0],
          o = r.ignore.join(','),
          i = (e) => e && (e.matches(o) || e.closest(o));
        if (i(t) || i(n)) return !1;
      }
      function A(e) {
        let t = Date.now();
        if (((x = x.filter((e) => !e.ts || e.ts > t - 100)), e && x.push(e), (b = 0), (E = 0), x.length > 3)) {
          let e = x[0],
            t = x[x.length - 1];
          if (e && t) {
            let n = t.x - e.x,
              o = t.y - e.y,
              i = e.ts && t.ts ? t.ts - e.ts : 0;
            i > 0 && ((b = Math.abs(n) > 3 ? n / (i / 30) : 0), (E = Math.abs(o) > 3 ? o / (i / 30) : 0));
          }
        }
      }
      function R(e) {
        if (!1 === P(e)) return;
        if ('undefined' != typeof MouseEvent && e instanceof MouseEvent) {
          if (K) return;
        } else K = !0;
        if ('undefined' != typeof MouseEvent && e instanceof MouseEvent) {
          if (!e.buttons || 0 !== e.button) return;
          X(e);
        }
        (e instanceof MouseEvent && (window.addEventListener('mousemove', C), window.addEventListener('mouseup', O)),
          window.addEventListener('blur', I),
          (i = e),
          (l = [...(a = B(e))]),
          (s = []),
          (m = a.length),
          (n = Z(a)),
          1 === m && ((c = !1), (u = !1), (d = !1)),
          m && A(Z(a)));
        let t = Date.now(),
          o = t - (g || t);
        ((f = o > 0 && o <= 250 && 1 === m), (g = t), clearTimeout(M), T('start'));
      }
      function C(e) {
        if (!l.length || e.defaultPrevented || !1 === P(e)) return;
        ((i = e), (s = [...a]), (a = N(e)));
        let t = Z(s),
          u = Z(N(e));
        if (
          (A(u),
          (m = a.length),
          (n = u),
          s.length === a.length ? ((p = u.x - t.x), (h = u.y - t.y)) : ((p = 0), (h = 0)),
          l.length)
        ) {
          let e = Z(l);
          ((y = u.x - e.x), (v = u.y - e.y));
        }
        (a.length > 1 && Math.abs(G(a) - G(s)) >= 0.1 && ((d = !0), T('pinch')),
          !c &&
            (c = Math.abs(y) > r.panThreshold || Math.abs(v) > r.panThreshold) &&
            ((J = !1),
            clearTimeout(L),
            (L = 0),
            (o = (w = Math.abs((180 * Math.atan2(v, y)) / Math.PI)) > 45 && w < 135 ? 'y' : 'x'),
            (l = [...a]),
            (s = [...a]),
            (y = 0),
            (v = 0),
            (p = 0),
            (h = 0),
            window.getSelection()?.removeAllRanges(),
            T('panstart')),
          c && (p || h) && T('pan'),
          T('move'));
      }
      function O(e) {
        if (((i = e), !l.length)) return;
        let t = B(e),
          o = W(e);
        if (((m = t.length), (n = Z(o)), o.length && A(Z(o)), (s = [...a]), (a = [...t]), (l = [...t]), m > 0))
          (T('end'), (c = !1), (u = !1), (x = []));
        else {
          let e = r.swipeThreshold;
          ((Math.abs(b) > e || Math.abs(E) > e) && (u = !0),
            c && T('panend'),
            u && T('swipe'),
            c ||
              u ||
              d ||
              (T('tap'),
              f
                ? T('doubleTap')
                : (M = setTimeout(function () {
                    T('singleTap');
                  }, 250))),
            T('end'),
            z());
        }
      }
      function I() {
        (clearTimeout(M), z(), c && T('panend'), T('end'));
      }
      function z() {
        ((K = !1),
          (c = !1),
          (u = !1),
          (f = !1),
          (m = 0),
          (x = []),
          (a = []),
          (s = []),
          (l = []),
          (p = 0),
          (h = 0),
          (y = 0),
          (v = 0),
          (b = 0),
          (E = 0),
          (w = 0),
          (o = void 0),
          window.removeEventListener('mousemove', C),
          window.removeEventListener('mouseup', O),
          window.removeEventListener('blur', I),
          J ||
            L ||
            (L = setTimeout(() => {
              ((J = !0), (L = 0));
            }, 100)));
      }
      function k(e) {
        let t = e.target;
        ((K = !1), t && !e.defaultPrevented && (J || (X(e), e.stopPropagation())));
      }
      let _ = {
        init: function () {
          return (
            e &&
              (e.addEventListener('click', k, Y),
              e.addEventListener('mousedown', R, Y),
              e.addEventListener('touchstart', R, Y),
              e.addEventListener('touchmove', C, Y),
              e.addEventListener('touchend', O),
              e.addEventListener('touchcancel', O)),
            _
          );
        },
        on: function (e, t) {
          return (S.set(e, [...(S.get(e) || []), t]), _);
        },
        off: function (e, t) {
          return (
            S.has(e) &&
              S.set(
                e,
                S.get(e).filter((e) => e !== t),
              ),
            _
          );
        },
        isPointerDown: () => m > 0,
        destroy: function () {
          (clearTimeout(M),
            clearTimeout(L),
            (L = 0),
            e &&
              (e.removeEventListener('click', k, Y),
              e.removeEventListener('mousedown', R, Y),
              e.removeEventListener('touchstart', R, Y),
              e.removeEventListener('touchmove', C, Y),
              e.removeEventListener('touchend', O),
              e.removeEventListener('touchcancel', O)),
            (e = null),
            z());
        },
      };
      return _;
    };
  Q.isClickAllowed = () => J;
  let ee = {
      IMAGE_ERROR: "This image couldn't be loaded. <br /> Please try again later.",
      MOVE_UP: 'Move up',
      MOVE_DOWN: 'Move down',
      MOVE_LEFT: 'Move left',
      MOVE_RIGHT: 'Move right',
      ZOOM_IN: 'Zoom in',
      ZOOM_OUT: 'Zoom out',
      TOGGLE_FULL: 'Toggle zoom level',
      TOGGLE_1TO1: 'Toggle zoom level',
      ITERATE_ZOOM: 'Toggle zoom level',
      ROTATE_CCW: 'Rotate counterclockwise',
      ROTATE_CW: 'Rotate clockwise',
      FLIP_X: 'Flip horizontally',
      FLIP_Y: 'Flip vertically',
      RESET: 'Reset',
      TOGGLE_FS: 'Toggle fullscreen',
    },
    et = 1e4,
    en = (e) => {
      e.cancelable && e.preventDefault();
    },
    eo = (e, t = et) => Math.round(((e = parseFloat(e + '') || 0) + Number.EPSILON) * t) / t,
    ei =
      (((A = {}).Reset = 'reset'),
      (A.Zoom = 'zoom'),
      (A.ZoomIn = 'zoomIn'),
      (A.ZoomOut = 'zoomOut'),
      (A.ZoomTo = 'zoomTo'),
      (A.ToggleCover = 'toggleCover'),
      (A.ToggleFull = 'toggleFull'),
      (A.ToggleMax = 'toggleMax'),
      (A.IterateZoom = 'iterateZoom'),
      (A.Pan = 'pan'),
      (A.Swipe = 'swipe'),
      (A.Move = 'move'),
      (A.MoveLeft = 'moveLeft'),
      (A.MoveRight = 'moveRight'),
      (A.MoveUp = 'moveUp'),
      (A.MoveDown = 'moveDown'),
      (A.RotateCCW = 'rotateCCW'),
      (A.RotateCW = 'rotateCW'),
      (A.FlipX = 'flipX'),
      (A.FlipY = 'flipY'),
      (A.ToggleFS = 'toggleFS'),
      A),
    er = (((R = {}).Cover = 'cover'), (R.Full = 'full'), (R.Max = 'max'), R),
    el = { x: 0, y: 0, scale: 1, angle: 0, flipX: 1, flipY: 1 },
    ea =
      (((C = {})[(C.Init = 0)] = 'Init'),
      (C[(C.Loading = 1)] = 'Loading'),
      (C[(C.Error = 2)] = 'Error'),
      (C[(C.Ready = 3)] = 'Ready'),
      (C[(C.Destroyed = 4)] = 'Destroyed'),
      C),
    es = {
      bounds: !0,
      classes: {
        container: 'f-panzoom',
        wrapper: 'f-panzoom__wrapper',
        content: 'f-panzoom__content',
        viewport: 'f-panzoom__viewport',
      },
      clickAction: ei.ToggleFull,
      dblClickAction: !1,
      gestures: {},
      height: 'auto',
      l10n: ee,
      maxScale: 4,
      minScale: 1,
      mouseMoveFactor: 1,
      panMode: 'drag',
      protected: !1,
      singleClickAction: !1,
      spinnerTpl: '<div class="f-spinner"></div>',
      wheelAction: ei.Zoom,
      width: 'auto',
    },
    ec = 0,
    eu = 0,
    ed = 0,
    ef = (e, n = {}, o = {}) => {
      let i,
        r,
        l,
        u,
        f,
        g,
        m,
        h,
        E = ea.Init,
        x = { ...es, ...n },
        M = {},
        L = { ...el },
        S = { ...el },
        T = [];
      function P(e) {
        let t = x[e];
        return t && 'function' == typeof t ? t(eS) : t;
      }
      function A() {
        return e && e.parentElement && i && E === ea.Ready;
      }
      let R = new Map();
      function C(e, ...t) {
        let n = [...(R.get(e) || [])];
        for (let o of (x.on && n.push(x.on[e]), n)) o && o instanceof Function && o(eS, ...t);
        '*' !== e && C('*', e, ...t);
      }
      function O(e) {
        if (!A() || d(e.target)) return;
        let t = Date.now(),
          n = p(
            -1,
            [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (e, t) {
              return Math.abs(t) > Math.abs(e) ? t : e;
            }),
            1,
          );
        C('wheel', e, n);
        let o = P('wheelAction');
        if (!o || e.defaultPrevented) return;
        let i = S.scale,
          r = i * (n > 0 ? 1.5 : 0.5);
        if (o === ei.Zoom) {
          let o = 100 > Math.abs(e.deltaY) && 100 > Math.abs(e.deltaX);
          if (t - eu < (o ? 200 : 45)) return void en(e);
          eu = t;
          let l = B(),
            a = U();
          if (
            (eo(r) < eo(l) && eo(i) <= eo(l)
              ? ((ed += Math.abs(n)), (r = l))
              : eo(r) > eo(a) && eo(i) >= eo(a)
                ? ((ed += Math.abs(n)), (r = a))
                : ((ed = 0), (r = p(l, r, a))),
            ed > 7)
          )
            return;
        }
        switch ((en(e), o)) {
          case ei.Pan:
            er(o, { srcEvent: e, deltaX: -(2 * e.deltaX), deltaY: -(2 * e.deltaY) });
            break;
          case ei.Zoom:
            er(ei.ZoomTo, { srcEvent: e, scale: r, center: { x: e.clientX, y: e.clientY } });
            break;
          default:
            er(o, { srcEvent: e });
        }
      }
      function I(n) {
        let o = n.composedPath()[0];
        if (
          !Q.isClickAllowed() ||
          !s(o) ||
          n.defaultPrevented ||
          !e?.contains(o) ||
          o.hasAttribute('disabled') ||
          o.hasAttribute('aria-disabled') ||
          o.hasAttribute('data-carousel-go-prev') ||
          o.hasAttribute('data-carousel-go-next')
        )
          return;
        let r = o.closest('[data-panzoom-action]'),
          l = r?.dataset?.panzoomAction,
          a = r?.dataset?.panzoomValue || '';
        if (l) {
          switch ((en(n), l)) {
            case ei.ZoomTo:
            case ei.ZoomIn:
            case ei.ZoomOut:
              er(l, { scale: parseFloat(a || '') || void 0 });
              break;
            case ei.MoveLeft:
            case ei.MoveRight:
              er(l, { deltaX: parseFloat(a || '') || void 0 });
              break;
            case ei.MoveUp:
            case ei.MoveDown:
              er(l, { deltaY: parseFloat(a || '') || void 0 });
              break;
            case ei.ToggleFS:
              eM();
              break;
            default:
              er(l);
          }
          return;
        }
        if (!i?.contains(o)) return;
        let c = { srcEvent: n };
        if ((er(P('clickAction'), c), P('dblClickAction'))) {
          let e = Date.now(),
            n = e - (ec || e);
          ((ec = e),
            n > 0 && n <= 250
              ? (t && (clearTimeout(t), (t = void 0)), er(P('dblClickAction'), c))
              : (t = setTimeout(() => {
                  er(P('singleClickAction'), c);
                }, 250)));
        }
      }
      function z(e) {
        if (
          ((h = e),
          !A() || !j() || L.scale <= 1 || S.scale <= 1 || (i?.dataset.animationName || '').indexOf('zoom') > -1)
        )
          return;
        let t = q(S.scale);
        if (!t) return;
        let { x: n, y: o } = t;
        er(ei.Pan, { deltaX: n - S.x, deltaY: o - S.y });
      }
      function k() {
        e && (v(e, 'is-loading'), e.querySelector('.f-spinner')?.remove());
      }
      function _() {
        if (!e || !r) return;
        if ((k(), r instanceof HTMLImageElement && !(r.complete && r.naturalWidth))) {
          ((E = ea.Error), i?.classList.add('has-error'), C('error'));
          return;
        }
        C('loaded');
        let { width: t, height: n } = H();
        (r instanceof HTMLImageElement && (r.setAttribute('width', t + ''), r.setAttribute('height', n + '')),
          i &&
            (v(i, 'has-error'),
            r instanceof HTMLImageElement &&
              (i.setAttribute('width', t + ''),
              i.setAttribute('height', n + ''),
              (i.style.aspectRatio = `${t / n || ''}`))),
          (g = V()
            .on('start', (e, t) => {
              (void 0 !== t.angle && (t.angle = 90 * Math.round(t.angle / 90)),
                void 0 !== t.flipX && (t.flipX = t.flipX > 0 ? 1 : -1),
                void 0 !== t.flipY && (t.flipY = t.flipY > 0 ? 1 : -1),
                (S = { ...el, ...t }),
                ee(),
                C('animationStart'));
            })
            .on('pause', (e) => {
              S = { ...el, ...e };
            })
            .on('step', (e) => {
              if (!A()) return void g?.end();
              if (((L = { ...el, ...e }), j() || !P('bounds') || eE() || S.scale > L.scale || S.scale < G()))
                return void ef();
              let t = K(S.scale),
                n = !1,
                o = !1,
                i = !1,
                r = !1;
              (L.x < t.x[0] && (n = !0), L.x > t.x[1] && (o = !0), L.y < t.y[0] && (r = !0), L.y > t.y[1] && (i = !0));
              let l = !1,
                a = !1,
                s = !1,
                c = !1;
              (S.x < t.x[0] && (l = !0), S.x > t.x[1] && (a = !0), S.y < t.y[0] && (c = !0), S.y > t.y[1] && (s = !0));
              let u = !1;
              (((o && a) || (n && l)) && ((S.x = p(t.x[0], S.x, t.x[1])), (u = !0)),
                ((i && s) || (r && c)) && ((S.y = p(t.y[0], S.y, t.y[1])), (u = !0)),
                u &&
                  g &&
                  g
                    .spring({
                      tension: 94,
                      friction: 17,
                      maxSpeed: 555 * S.scale,
                      restDelta: 0.1,
                      restSpeed: 0.1,
                      velocity: g.getCurrentVelocities(),
                    })
                    .from(L)
                    .to(S)
                    .start(),
                ef());
            })
            .on('end', () => {
              (f?.isPointerDown() || J(), g?.isRunning() || (ee(), C('animationEnd')));
            })),
          (function () {
            let e = P('gestures');
            if (!e || !u || !r) return;
            let t = !1;
            f = Q(u, e)
              .on('start', (e) => {
                if (!P('gestures') || !g || !A() || j()) return;
                let n = e.srcEvent;
                ((L.scale > 1 || e.currentTouch.length > 1) && (n?.stopPropagation(), g.pause(), (t = !0)),
                  1 === e.currentTouch.length && C('touchStart'));
              })
              .on('move', (e) => {
                t && (1 !== S.scale || e.currentTouch.length > 1) && (en(e.srcEvent), e.srcEvent?.stopPropagation());
              })
              .on('pan', (e) => {
                if (!t) return;
                let n = e.srcEvent;
                (1 !== S.scale || e.currentTouch.length > 1) && (en(n), er(ei.Pan, e));
              })
              .on('swipe', (e) => {
                t && S.scale > 1 && er(ei.Swipe, e);
              })
              .on('tap', (e) => {
                C('click', e);
              })
              .on('singleTap', (e) => {
                C('singleClick', e);
              })
              .on('doubleTap', (e) => {
                C('dblClick', e);
              })
              .on('pinch', (e) => {
                t && (e.scale > G() ? er(ei.ZoomIn, e) : e.scale < G() ? er(ei.ZoomOut, e) : er(ei.Pan, e));
              })
              .on('end', (e) => {
                t &&
                  (e.currentTouch.length
                    ? (e.srcEvent.stopPropagation(), en(e.srcEvent), g?.end())
                    : ((t = !1), ee(), J(), C('touchEnd')));
              })
              .init();
          })(),
          u &&
            (u.addEventListener('wheel', O, { passive: !1 }),
            T.push(() => {
              u?.removeEventListener('wheel', O, { passive: !1 });
            })),
          e?.addEventListener('click', I),
          document?.addEventListener('mousemove', z),
          T.push(() => {
            (e?.removeEventListener('click', I), document?.removeEventListener('mousemove', z));
          }));
        let o = $();
        ((L = { ...o }),
          (S = { ...o }),
          (E = ea.Ready),
          ef(),
          ee(),
          C('ready'),
          requestAnimationFrame(() => {
            (k(), u && (u.style.visibility = ''));
          }));
      }
      function $() {
        let e = { ...(P('startPos') || {}) },
          t = e.scale,
          n = 1;
        n = 'string' == typeof t ? N(t) : 'number' == typeof t ? t : G();
        let o = { ...el, ...e, scale: n },
          i = j() ? q(n) : void 0;
        if (i) {
          let { x: e, y: t } = i;
          ((o.x = e), (o.y = t));
        }
        return o;
      }
      function F() {
        let e = { top: 0, left: 0, width: 0, height: 0 };
        if (i) {
          let t = i.getBoundingClientRect();
          S.angle % 180 == 90
            ? ((e.top = t.top + 0.5 * t.height - 0.5 * t.width),
              (e.left = t.left + 0.5 * t.width - 0.5 * t.height),
              (e.width = t.height),
              (e.height = t.width))
            : ((e.top = t.top), (e.left = t.left), (e.width = t.width), (e.height = t.height));
        }
        return e;
      }
      function H() {
        let e = P('width'),
          t = P('height');
        if (r && 'auto' === e) {
          let t = r.getAttribute('width');
          e = t
            ? parseFloat(t + '')
            : void 0 !== r.dataset.width
              ? parseFloat(r.dataset.width + '')
              : u instanceof HTMLImageElement
                ? u.naturalWidth
                : r instanceof HTMLImageElement
                  ? r.naturalWidth
                  : i?.getBoundingClientRect().width || 0;
        } else e = a(e) ? parseFloat(e) : e;
        if (r && 'auto' === t) {
          let e = r.getAttribute('height');
          t = e
            ? parseFloat(e + '')
            : void 0 !== r.dataset.height
              ? parseFloat(r.dataset.height + '')
              : u instanceof HTMLImageElement
                ? u.naturalHeight
                : r instanceof HTMLImageElement
                  ? r.naturalHeight
                  : i?.getBoundingClientRect().height || 0;
        } else t = a(t) ? parseFloat(t) : t;
        return { width: e, height: t };
      }
      function D() {
        let e = F();
        return { width: e.width, height: e.height };
      }
      function j() {
        return 'mousemove' === P('panMode') && matchMedia('(hover: hover)').matches;
      }
      function q(e) {
        let t = h || P('event'),
          n = i?.getBoundingClientRect();
        if (!t || !n || e <= 1) return { x: 0, y: 0 };
        let o = (t.clientX || 0) - n.left,
          r = (t.clientY || 0) - n.top,
          { width: l, height: a } = D(),
          s = K(e);
        if (e > 1) {
          let t = P('mouseMoveFactor');
          t > 1 && (e *= t);
        }
        let c = l * e,
          u = a * e,
          d = (c - l) * 0.5 - (((o / l) * 100) / 100) * (c - l),
          f = (u - a) * 0.5 - (((r / a) * 100) / 100) * (u - a);
        return { x: (d = p(s.x[0], d, s.x[1])), y: (f = p(s.y[0], f, s.y[1])) };
      }
      function N(t = 'base') {
        if (!e) return 1;
        let n = e.getBoundingClientRect(),
          o = F(),
          { width: i, height: r } = H(),
          l = (e) => {
            if ('number' == typeof e) return e;
            switch (e) {
              case 'min':
              case 'base':
                return 1;
              case 'cover':
                return Math.max(n.height / o.height, n.width / o.width) || 1;
              case 'full':
              case 'max': {
                let e = S.angle % 180 == 90 ? r : i;
                return e && o.width ? e / o.width : 1;
              }
            }
          },
          a = P('minScale'),
          s = P('maxScale'),
          c = Math.min(l('full'), l(a)),
          u = 'number' == typeof s ? l('full') * s : Math.min(l('full'), l(s));
        switch (t) {
          case 'min':
            return c;
          case 'base':
            return p(c, 1, u);
          case 'cover':
            return l('cover');
          case 'full':
            return Math.min(u, l('full'));
          case 'max':
            return u;
        }
      }
      function B() {
        return N('min');
      }
      function G() {
        return N('base');
      }
      function X() {
        return N('cover');
      }
      function Y() {
        return N('full');
      }
      function U() {
        return N('max');
      }
      function K(t) {
        let n = { x: [0, 0], y: [0, 0] },
          o = e?.getBoundingClientRect();
        if (!o) return n;
        let i = F(),
          r = o.width,
          l = o.height,
          a = i.width,
          s = i.height,
          c = (t = void 0 === t ? S.scale : t),
          u = t;
        if (j() && t > 1) {
          let e = P('mouseMoveFactor');
          e > 1 && (a * t > r + 0.01 && (c *= e), s * t > l + 0.01 && (u *= e));
        }
        return (
          (a *= c),
          (s *= u),
          t > 1 &&
            (a > r && ((n.x[0] = (r - a) * 0.5), (n.x[1] = (a - r) * 0.5)),
            (n.x[0] -= (i.left - o.left) * 0.5),
            (n.x[1] -= (i.left - o.left) * 0.5),
            (n.x[0] -= (i.left + i.width - o.right) * 0.5),
            (n.x[1] -= (i.left + i.width - o.right) * 0.5),
            s > l && ((n.y[0] = (l - s) * 0.5), (n.y[1] = (s - l) * 0.5)),
            (n.y[0] -= (i.top - o.top) * 0.5),
            (n.y[1] -= (i.top - o.top) * 0.5),
            (n.y[0] -= (i.top + i.height - o.bottom) * 0.5),
            (n.y[1] -= (i.top + i.height - o.bottom) * 0.5)),
          n
        );
      }
      function J() {
        if (!A() || !P('bounds') || !g) return;
        let e = B(),
          t = U(),
          n = p(e, S.scale, t);
        if (S.scale < e - 0.01 || S.scale > t + 0.01) return void er(ei.ZoomTo, { scale: n });
        if (g.isRunning() || eE()) return;
        let o = K(n);
        S.x < o.x[0] || S.x > o.x[1] || S.y < o.y[0] || S.y > o.y[1]
          ? ((S.x = p(o.x[0], S.x, o.x[1])),
            (S.y = p(o.y[0], S.y, o.y[1])),
            g.spring({
              tension: 170,
              friction: 17,
              restDelta: 0.001,
              restSpeed: 0.001,
              maxSpeed: 1 / 0,
              velocity: g.getCurrentVelocities(),
            }),
            g.from(L).to(S).start())
          : ef();
      }
      function ee(t) {
        if (!A()) return;
        let n = eb(),
          o = eE(),
          r = ew(),
          l = ex(),
          a = em(),
          s = ep();
        (b(i, 'is-fullsize', l),
          b(i, 'is-expanded', r),
          b(i, 'is-dragging', o),
          b(i, 'can-drag', n),
          b(i, 'will-zoom-in', a),
          b(i, 'will-zoom-out', s));
        let c = ey(),
          u = ev(),
          d = eh(),
          f = !A();
        for (let n of (t || e)?.querySelectorAll('[data-panzoom-action]') || []) {
          let e = n.dataset.panzoomAction,
            t = !1;
          if (f) t = !0;
          else
            switch (e) {
              case ei.ZoomIn:
                c || (t = !0);
                break;
              case ei.ZoomOut:
                d || (t = !0);
                break;
              case ei.ToggleFull: {
                u || d || (t = !0);
                let e = n.querySelector('g');
                e && (e.style.display = l && !t ? 'none' : '');
                break;
              }
              case ei.IterateZoom: {
                c || d || (t = !0);
                let e = n.querySelector('g');
                e && (e.style.display = c || t ? '' : 'none');
                break;
              }
              case ei.ToggleCover:
              case ei.ToggleMax:
                c || d || (t = !0);
            }
          t
            ? (n.setAttribute('aria-disabled', ''), n.setAttribute('tabindex', '-1'))
            : (n.removeAttribute('aria-disabled'), n.removeAttribute('tabindex'));
        }
      }
      function er(t, n) {
        if (!t || !e || !r || !g || !A() || (t === ei.Swipe && Math.abs(g.getCurrentVelocities().scale) > 0.01)) return;
        let o = { ...S },
          i = { ...S },
          l = K(j() ? o.scale : L.scale),
          a = g.getCurrentVelocities(),
          s = F();
        n = n || {};
        let c = (n.currentTouch?.length || 0) > 1,
          u = n.velocityX || 0,
          d = n.velocityY || 0,
          f = n.center;
        n.srcEvent && (f = Z(W(n.srcEvent)));
        let m = n.deltaX || 0,
          h = n.deltaY || 0;
        switch (t) {
          case ei.MoveRight:
            m = n.deltaX || 100;
            break;
          case ei.MoveLeft:
            m = n.deltaX || -100;
            break;
          case ei.MoveUp:
            h = n.deltaY || -100;
            break;
          case ei.MoveDown:
            h = n.deltaY || 100;
        }
        let y = [];
        switch (t) {
          case ei.Reset:
            (i = { ...el }).scale = G();
            break;
          case ei.Pan:
          case ei.Move:
          case ei.MoveLeft:
          case ei.MoveRight:
          case ei.MoveUp:
          case ei.MoveDown:
            if (eE()) {
              let e = 1,
                t = 1;
              (i.x <= l.x[0] &&
                u <= 0 &&
                (e = 0.2 * Math.max(0.01, 1 - Math.abs((1 / s.width) * Math.abs(i.x - l.x[0])))),
                i.x >= l.x[1] &&
                  u >= 0 &&
                  (e = 0.2 * Math.max(0.01, 1 - Math.abs((1 / s.width) * Math.abs(i.x - l.x[1])))),
                i.y <= l.y[0] &&
                  d <= 0 &&
                  (t = 0.2 * Math.max(0.01, 1 - Math.abs((1 / s.height) * Math.abs(i.y - l.y[0])))),
                i.y >= l.y[1] &&
                  d >= 0 &&
                  (t = 0.2 * Math.max(0.01, 1 - Math.abs((1 / s.height) * Math.abs(i.y - l.y[1])))),
                (i.x += m * e),
                (i.y += h * t));
            } else ((i.x = p(l.x[0], i.x + m, l.x[1])), (i.y = p(l.y[0], i.y + h, l.y[1])));
            break;
          case ei.Swipe:
            let v = (e = 0) => Math.sign(e) * Math.pow(Math.abs(e), 1.5);
            ((i.x += p(-1e3, v(u), 1e3)),
              (i.y += p(-1e3, v(d), 1e3)),
              d && !u && (i.x = p(l.x[0], i.x, l.x[1])),
              !d && u && (i.y = p(l.y[0], i.y, l.y[1])),
              (a.x = u),
              (a.y = d));
            break;
          case ei.ZoomTo:
            i.scale = n.scale || 1;
            break;
          case ei.ZoomIn:
            ((i.scale = i.scale * (n.scale || 2)), c || (i.scale = Math.min(i.scale, U())));
            break;
          case ei.ZoomOut:
            ((i.scale = i.scale * (n.scale || 0.5)), c || (i.scale = Math.max(i.scale, B())));
            break;
          case ei.ToggleCover:
            y = [G(), X()];
            break;
          case ei.ToggleFull:
            y = [G(), Y()];
            break;
          case ei.ToggleMax:
            y = [G(), U()];
            break;
          case ei.IterateZoom:
            y = [G(), Y(), U()];
            break;
          case ei.Zoom:
            let b = Y();
            i.scale >= b - 0.05 ? (i.scale = G()) : (i.scale = Math.min(b, i.scale * (n.scale || 2)));
            break;
          case ei.RotateCW:
            i.angle += 90;
            break;
          case ei.RotateCCW:
            i.angle -= 90;
            break;
          case ei.FlipX:
            i.flipX *= -1;
            break;
          case ei.FlipY:
            i.flipY *= -1;
        }
        if (
          (void 0 !== L.angle &&
            Math.abs(L.angle) >= 360 &&
            ((i.angle -= 360 * Math.floor(L.angle / 360)), (L.angle -= 360 * Math.floor(L.angle / 360))),
          y.length)
        ) {
          let e = y.findIndex((e) => e > i.scale + 1 / et);
          i.scale = y[e] || y[0];
        }
        if ((c && (i.scale = p(B() * (c ? 0.8 : 1), i.scale, U() * (c ? 1.6 : 1))), j())) {
          let e = q(i.scale);
          if (e) {
            let { x: t, y: n } = e;
            ((i.x = t), (i.y = n));
          }
        } else if (Math.abs(i.scale - o.scale) > 1e-4) {
          let t = 0,
            n = 0;
          if (f) ((t = f.x), (n = f.y));
          else {
            let o = e.getBoundingClientRect();
            ((t = o.x + 0.5 * o.width), (n = o.y + 0.5 * o.height));
          }
          let r = t - s.left,
            a = n - s.top;
          ((r -= 0.5 * s.width), (a -= 0.5 * s.height));
          let u = (r - o.x) / o.scale,
            d = (a - o.y) / o.scale;
          ((i.x = r - u * i.scale),
            (i.y = a - d * i.scale),
            !c && P('bounds') && ((l = K(i.scale)), (i.x = p(l.x[0], i.x, l.x[1])), (i.y = p(l.y[0], i.y, l.y[1]))));
        }
        if (t === ei.Swipe) {
          let e = 500 * i.scale;
          g.spring({ tension: 94, friction: 17, maxSpeed: e, restDelta: 0.1, restSpeed: 0.1, velocity: a });
        } else
          t === ei.Pan || c
            ? g.spring({ tension: 900, friction: 17, restDelta: 0.01, restSpeed: 0.01, maxSpeed: 1 })
            : g.spring({
                tension: 170,
                friction: 17,
                restDelta: 0.001,
                restSpeed: 0.001,
                maxSpeed: 1 / 0,
                velocity: a,
              });
        if (0 === n.velocity || w(L, i)) ((L = { ...i }), (S = { ...i }), g.end(), ef(), ee());
        else {
          if (w(S, i)) return;
          g.from(L).to(i).start();
        }
        C('action', t);
      }
      function ef() {
        if (!r || !i || !u) return;
        let { width: t, height: n } = H();
        Object.assign(i.style, { maxWidth: `min(${t}px, 100%)`, maxHeight: `min(${n}px, 100%)` });
        let {
            x: o,
            y: l,
            width: a,
            height: s,
            scale: c,
            angle: d,
            flipX: f,
            flipY: g,
          } = (function () {
            let { width: t, height: n } = H(),
              { width: o, height: i } = D();
            if (!e)
              return {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                scale: 0,
                flipX: 0,
                flipY: 0,
                angle: 0,
                fitWidth: o,
                fitHeight: i,
                fullWidth: t,
                fullHeight: n,
              };
            let { x: r, y: l, scale: a, angle: s, flipX: c, flipY: u } = L,
              d = 1 / Y(),
              f = t,
              g = n,
              m = L.scale * d,
              p = S.scale * d,
              h = Math.max(o, i),
              y = Math.min(o, i);
            (t > n ? ((f = h), (g = y)) : ((f = y), (g = h)), (m = t > n ? (h * a) / t || 1 : (h * a) / n || 1));
            let v = f ? t * p : 0,
              b = g ? n * p : 0,
              E = f && g ? (t * m) / v : 0;
            return {
              x: (r = r + 0.5 * f - 0.5 * v),
              y: (l = l + 0.5 * g - 0.5 * b),
              width: v,
              height: b,
              scale: E,
              flipX: c,
              flipY: u,
              angle: s,
              fitWidth: o,
              fitHeight: i,
              fullWidth: t,
              fullHeight: n,
            };
          })(),
          m = `translate(${eo(o)}px, ${eo(l)}px)`;
        (1 !== f || 1 !== g ? (m += ` scaleX(${eo(c * f)}) scaleY(${eo(c * g)})`) : (m += ` scale(${eo(c)})`),
          0 !== d && (m += ` rotate(${d}deg)`),
          (u.style.width = `${eo(a)}px`),
          (u.style.height = `${eo(s)}px`),
          (u.style.transform = `${m}`),
          C('render'));
      }
      function eg() {
        let e = S.scale,
          t,
          n = P('clickAction'),
          o = G();
        if (n) {
          let i = [];
          switch (n) {
            case ei.ZoomIn:
              o = e * (t || 2);
              break;
            case ei.ZoomOut:
              o = e * (t || 0.5);
              break;
            case ei.ToggleCover:
              i = [G(), X()];
              break;
            case ei.ToggleFull:
              i = [G(), Y()];
              break;
            case ei.ToggleMax:
              i = [G(), U()];
              break;
            case ei.IterateZoom:
              i = [G(), Y(), U()];
              break;
            case ei.Zoom:
              let r = Y();
              o = e >= r - 0.05 ? G() : Math.min(r, e * (t || 2));
          }
          if (i.length) {
            let t = i.findIndex((t) => t > e + 1 / et);
            o = i[t] || G();
          }
        }
        return p(B(), o, U());
      }
      function em() {
        return !!(A() && eg() > S.scale);
      }
      function ep() {
        return !!(A() && eg() < S.scale);
      }
      function eh() {
        return !!(A() && S.scale > B());
      }
      function ey() {
        return !!(A() && S.scale < U());
      }
      function ev() {
        return !!(A() && S.scale < Y());
      }
      function eb() {
        return !!(A() && ew() && f && !j());
      }
      function eE() {
        return !!(A() && f?.isPointerDown() && !j());
      }
      function ew() {
        return !!(A() && S.scale > G());
      }
      function ex() {
        return !!(A() && S.scale >= Y());
      }
      function eM() {
        let t = 'in-fullscreen',
          n = 'with-panzoom-in-fullscreen';
        e?.classList.toggle(t);
        let o = e?.classList.contains(t);
        (o
          ? (document.documentElement.classList.add(n), document.addEventListener('keydown', eL, !0))
          : (document.documentElement.classList.remove(n), document.removeEventListener('keydown', eL, !0)),
          ef(),
          C(o ? 'enterFS' : 'exitFS'));
      }
      function eL(e) {
        'Escape' !== e.key || e.defaultPrevented || eM();
      }
      let eS = {
        canDrag: eb,
        canZoomIn: ey,
        canZoomOut: eh,
        canZoomToFull: ev,
        destroy: function () {
          for (let e of (C('destroy'), Object.values(M))) e?.destroy(eS);
          for (let e of T) e();
          return (
            i && ((i.style.aspectRatio = ''), (i.style.maxWidth = ''), (i.style.maxHeight = '')),
            u && ((u.style.width = ''), (u.style.height = ''), (u.style.transform = '')),
            (i = void 0),
            (r = void 0),
            (u = void 0),
            (L = { ...el }),
            (S = { ...el }),
            g?.destroy(),
            (g = void 0),
            f?.destroy(),
            (f = void 0),
            (E = ea.Destroyed),
            eS
          );
        },
        emit: C,
        execute: er,
        getBoundaries: K,
        getContainer: function () {
          return e;
        },
        getContent: function () {
          return r;
        },
        getFullDim: H,
        getGestures: function () {
          return f;
        },
        getMousemovePos: q,
        getOptions: function () {
          return x;
        },
        getPlugins: function () {
          return M;
        },
        getScale: N,
        getStartPosition: $,
        getState: function () {
          return E;
        },
        getTransform: function (e) {
          return !0 === e ? S : L;
        },
        getTween: function () {
          return g;
        },
        getViewport: function () {
          return u;
        },
        getWrapper: function () {
          return i;
        },
        init: function () {
          return (
            (E = ea.Init),
            C('init'),
            (function () {
              for (let [e, t] of Object.entries({ ...o, ...(x.plugins || {}) }))
                if (e && !M[e] && t instanceof Function) {
                  let n = t();
                  (n.init(eS), (M[e] = n));
                }
              C('initPlugins');
            })(),
            (function () {
              let t = { ...es.classes, ...P('classes') };
              if (e && (y(e, t.container), (r = e.querySelector('.' + t.content)))) {
                if (
                  (r.setAttribute('draggable', 'false'),
                  (i = e.querySelector('.' + t.wrapper)) ||
                    (y((i = document.createElement('div')), t.wrapper),
                    r.insertAdjacentElement('beforebegin', i),
                    i.insertAdjacentElement('afterbegin', r)),
                  (u = e.querySelector('.' + t.viewport)) ||
                    (y((u = document.createElement('div')), t.viewport),
                    u.insertAdjacentElement('afterbegin', r),
                    i.insertAdjacentElement('beforeend', u)),
                  (l = r.cloneNode(!0)).removeAttribute('id'),
                  i.insertAdjacentElement('afterbegin', l),
                  r instanceof HTMLPictureElement && (r = r.querySelector('img')),
                  l instanceof HTMLPictureElement && (l = l.querySelector('img')),
                  u instanceof HTMLPictureElement && (u = u.querySelector('img')),
                  u && ((u.style.visibility = 'hidden'), P('protected')))
                ) {
                  u.addEventListener('contextmenu', (e) => {
                    en(e);
                  });
                  let e = document.createElement('div');
                  (y(e, 'f-panzoom__protected'), u.appendChild(e));
                }
                C('initLayout');
              }
            })(),
            (function () {
              if (e && i && !m) {
                let e = null;
                ((m = new ResizeObserver(() => {
                  A() &&
                    (e =
                      e ||
                      requestAnimationFrame(() => {
                        (A() && (ee(), J(), C('refresh')), (e = null));
                      }));
                })).observe(i),
                  T.push(() => {
                    (m?.disconnect(), (m = void 0), e && (cancelAnimationFrame(e), (e = null)));
                  }));
              }
            })(),
            (function () {
              if (!e || !r) return;
              if (!(r instanceof HTMLImageElement && l instanceof HTMLImageElement)) return _();
              let t = () => {
                r &&
                  r instanceof HTMLImageElement &&
                  r
                    .decode()
                    .then(() => {
                      _();
                    })
                    .catch(() => {
                      _();
                    });
              };
              ((E = ea.Loading), e.classList.add('is-loading'), C('loading'), l.src && l.complete)
                ? t()
                : ((function () {
                    if (!e || e?.querySelector('.f-spinner')) return;
                    let t = c(P('spinnerTpl'));
                    t &&
                      (t.classList.add('f-spinner'),
                      e.classList.add('is-loading'),
                      i?.insertAdjacentElement('afterbegin', t));
                  })(),
                  l.addEventListener('load', t, !1),
                  l.addEventListener('error', t, !1),
                  T.push(() => {
                    (l?.removeEventListener('load', t, !1), l?.removeEventListener('error', t, !1));
                  }));
            })(),
            eS
          );
        },
        isDragging: eE,
        isExpanded: ew,
        isFullsize: ex,
        isMousemoveMode: j,
        localize: function (e, t = []) {
          let n = P('l10n') || {};
          e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t) => n[t] || e);
          for (let n = 0; n < t.length; n++) e = e.split(t[n][0]).join(t[n][1]);
          return e.replace(/\{\{(.*?)\}\}/g, (e, t) => t);
        },
        off: function (e, t) {
          for (let n of e instanceof Array ? e : [e])
            R.has(n) &&
              R.set(
                n,
                R.get(n).filter((e) => e !== t),
              );
          return eS;
        },
        on: function (e, t) {
          for (let n of e instanceof Array ? e : [e]) R.set(n, [...(R.get(n) || []), t]);
          return eS;
        },
        toggleFS: eM,
        updateControls: ee,
        version: '6.1.6',
        willZoomIn: em,
        willZoomOut: ep,
      };
      return eS;
    };
  ((ef.l10n = { en_EN: ee }), (ef.getDefaults = () => es));
  let eg = (e, t) => {
      let n = [];
      return (
        e.childNodes.forEach((e) => {
          e.nodeType === Node.ELEMENT_NODE && (!t || e.matches(t)) && n.push(e);
        }),
        n
      );
    },
    em = {
      ...ee,
      ERROR: 'Something went wrong. <br /> Please try again later.',
      NEXT: 'Next page',
      PREV: 'Previous page',
      GOTO: 'Go to page #%d',
      DOWNLOAD: 'Download',
      TOGGLE_FULLSCREEN: 'Toggle full-screen mode',
      TOGGLE_EXPAND: 'Toggle full-size mode',
      TOGGLE_THUMBS: 'Toggle thumbnails',
      TOGGLE_AUTOPLAY: 'Toggle slideshow',
    },
    ep = (e) => {
      e.cancelable && e.preventDefault();
    },
    eh = (((O = {})[(O.Init = 0)] = 'Init'), (O[(O.Ready = 1)] = 'Ready'), (O[(O.Destroyed = 2)] = 'Destroyed'), O),
    ey = (((I = {})[(I.Loading = 0)] = 'Loading'), (I[(I.Loaded = 1)] = 'Loaded'), (I[(I.Error = 2)] = 'Error'), I),
    ev = {
      adaptiveHeight: !1,
      center: !0,
      classes: {
        container: 'f-carousel',
        isEnabled: 'is-enabled',
        isLTR: 'is-ltr',
        isRTL: 'is-rtl',
        isHorizontal: 'is-horizontal',
        isVertical: 'is-vertical',
        hasAdaptiveHeight: 'has-adaptive-height',
        viewport: 'f-carousel__viewport',
        slide: 'f-carousel__slide',
        isSelected: 'is-selected',
      },
      dragFree: !1,
      enabled: !0,
      errorTpl: '<div class="f-html">{{ERROR}}</div>',
      fill: !1,
      infinite: !0,
      initialPage: 0,
      l10n: em,
      rtl: !1,
      slides: [],
      slidesPerPage: 'auto',
      spinnerTpl: '<div class="f-spinner"></div>',
      transition: 'fade',
      tween: { clamp: !0, mass: 1, tension: 160, friction: 25, restDelta: 1, restSpeed: 1, velocity: 0 },
      vertical: !1,
    },
    eb = 0,
    eE = (e, t = {}, o = {}) => {
      let i, r, u, f, m;
      eb++;
      let E = eh.Init,
        w = { ...ev },
        x = { ...ev },
        M = {},
        L = null,
        S = null,
        T = 0,
        P = 0,
        A = 0,
        R = !1,
        C = !1,
        O = !1,
        I = 'height',
        z = 0,
        k = !0,
        _ = 0,
        $ = 0,
        F = 0,
        H = 0,
        D = '*',
        q = [],
        N = [],
        B = new Set(),
        W = [],
        Z = [],
        G = 0,
        X = 0,
        Y = 0;
      function U(e, ...t) {
        let n = x[e];
        return n && n instanceof Function ? n(e$, ...t) : n;
      }
      function K(e, t = []) {
        let n = U('l10n') || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t) => n[t] || e);
        for (let n = 0; n < t.length; n++) e = e.split(t[n][0]).join(t[n][1]);
        return e.replace(/\{\{(.*?)\}\}/g, (e, t) => t);
      }
      let J = new Map();
      function ee(e, ...t) {
        let n = [...(J.get(e) || [])];
        for (let o of (x.on && n.push(x.on[e]), n)) o && o instanceof Function && o(e$, ...t);
        '*' !== e && ee('*', e, ...t);
      }
      function et() {
        let e = g({}, ev, w);
        g(e, ev, w);
        let t = '',
          n = w.breakpoints || {};
        if (n) for (let [o, i] of Object.entries(n)) window.matchMedia(o).matches && ((t += o), g(e, i));
        if (void 0 === m || t !== m) {
          if (((m = t), E !== eh.Init)) {
            let t = Z[_]?.slides[0]?.index;
            for (let n of (void 0 === t && (t = x.initialSlide), (e.initialSlide = t), (e.slides = []), q))
              n.isVirtual && e.slides.push(n);
          }
          (ez(),
            (x = e),
            !1 !== U('enabled') &&
              ((E = eh.Init),
              ee('init'),
              (function () {
                for (let [e, t] of Object.entries({ ...o, ...(x.plugins || {}) }))
                  if (e && !M[e] && t instanceof Function) {
                    let n = t();
                    (n.init(e$, eE), (M[e] = n));
                  }
                ee('initPlugins');
              })(),
              (function () {
                if (!L) return;
                let e = U('classes') || {};
                y(L, e.container);
                let t = U('style');
                if (t && l(t)) for (let [e, n] of Object.entries(t)) L.style.setProperty(e, n);
                ((S = L.querySelector(`.${e.viewport}`)) ||
                  (y((S = document.createElement('div')), e.viewport),
                  S.append(...eg(L, `.${e.slide}`)),
                  L.insertAdjacentElement('afterbegin', S)),
                  (L.carousel = e$),
                  ee('initLayout'));
              })(),
              (function () {
                if (!S) return;
                let e = U('classes') || {};
                for (let t of ((q = []),
                [...eg(S, `.${e.slide}`)].forEach((e) => {
                  if (e.parentElement) {
                    let t = ef({ el: e, isVirtual: !1, ...(e.dataset || {}) });
                    (ee('createSlide', t), q.push(t));
                  }
                }),
                ew(),
                q))
                  ee('addSlide', t);
                for (let e of (ed(U('slides')), q)) {
                  let t = e.el;
                  t?.parentElement === S && (y(t, x.classes.slide), y(t, e.class), eR(e), ee('attachSlideEl', e));
                }
                ee('initSlides');
              })(),
              ex(),
              (E = eh.Ready),
              y(L, (U('classes') || {}).isEnabled || ''),
              eI(),
              el(),
              (r = V()
                .on('start', () => {
                  (i && i.isPointerDown()) || (er(), eI());
                })
                .on('step', (e) => {
                  let t = z;
                  (z = e.pos) !== t && ((k = !1), eI());
                })
                .on('end', (e) => {
                  !i?.isPointerDown() &&
                    ((z = e.pos),
                    r && !R && (z < F || z > H)
                      ? r
                          .spring({
                            clamp: !0,
                            mass: 1,
                            tension: 200,
                            friction: 25,
                            velocity: 0,
                            restDelta: 1,
                            restSpeed: 1,
                          })
                          .from({ pos: z })
                          .to({ pos: p(F, z, H) })
                          .start()
                      : k || ((k = !0), ee('settle')));
                })),
              eo(),
              (function () {
                if (!L || !S) return;
                (L.addEventListener('click', eT), document.addEventListener('mousemove', en));
                let e = S.getBoundingClientRect();
                if (((G = e.height), (X = e.width), !u)) {
                  let e = null;
                  (u = new ResizeObserver(() => {
                    e ||
                      (e = requestAnimationFrame(() => {
                        ((function () {
                          if (E !== eh.Ready || !S) return;
                          let e = Z.length,
                            t = S.getBoundingClientRect(),
                            n = t.height,
                            o = t.width;
                          (e > 1 && ((O && 0.5 > Math.abs(n - G)) || (!O && 0.5 > Math.abs(o - X)))) ||
                            (ex(),
                            eo(),
                            (G = n),
                            (X = o),
                            (O && !G) ||
                              (!O && !X) ||
                              (L &&
                                S &&
                                ((e === Z.length && i?.isPointerDown()) ||
                                  (U('dragFree') && (R || (z > F && z < H))
                                    ? (er(), eI())
                                    : eC(_, { transition: !1 })))));
                        })(),
                          (e = null));
                      }));
                  })).observe(S);
                }
              })(),
              ee('ready')));
        }
      }
      function en(e) {
        n = e;
      }
      function eo() {
        if (!1 === U('gestures')) i && (i.destroy(), (i = void 0));
        else {
          let e;
          i ||
            ((e = U('gestures')),
            !i &&
              !1 !== e &&
              S &&
              (i = Q(S, e)
                .on('start', (e) => {
                  if (!r || !1 === U('gestures', e)) return;
                  let { srcEvent: t } = e;
                  (O && j(t) && !d(t.target) && ep(t), r.pause(), (r.getCurrentVelocities().pos = 0));
                  let n = Z[_]?.slides[0],
                    o = n?.el;
                  if (n && B.has(n.index) && o) {
                    let e;
                    z =
                      (n.offset || 0) +
                      ({
                        width: (e = new DOMMatrixReadOnly(window.getComputedStyle(o).transform)).m41 || 0,
                        height: e.m42 || 0,
                      }[I] || 0) *
                        (C && !O ? 1 : -1);
                  }
                  (eL(),
                    !R &&
                      (z < F || z > H) &&
                      r
                        .spring({
                          clamp: !0,
                          mass: 1,
                          tension: 500,
                          friction: 25,
                          velocity: r.getCurrentVelocities()?.pos || 0,
                          restDelta: 1,
                          restSpeed: 1,
                        })
                        .from({ pos: z })
                        .to({ pos: p(F, z, H) })
                        .start());
                })
                .on('move', (e) => {
                  if (!1 === U('gestures', e)) return;
                  let { srcEvent: t, axis: n, deltaX: o, deltaY: i } = e;
                  if (j(t) && t.touches?.length > 1) return;
                  let l = d(t.target),
                    a = l ? (l.scrollHeight > l.clientHeight ? 'y' : 'x') : void 0;
                  if (l && l !== S && (!n || n === a)) return;
                  if (!n) {
                    (ep(t), t.stopPropagation(), t.stopImmediatePropagation());
                    return;
                  }
                  if (('y' === n && !O) || ('x' === n && O) || (ep(t), t.stopPropagation(), !r)) return;
                  let s = C && !O ? 1 : -1,
                    c = O ? i : o,
                    u = r?.isRunning() ? r.getEndValues().pos : z,
                    f = 1;
                  (!R &&
                    (u <= F && c * s < 0
                      ? (f = 0.2 * Math.max(0.01, 1 - (Math.abs((1 / T) * Math.abs(u - F)) || 0)))
                      : u >= H &&
                        c * s > 0 &&
                        (f = 0.2 * Math.max(0.01, 1 - (Math.abs((1 / T) * Math.abs(u - H)) || 0)))),
                    (u += c * f * s),
                    r
                      .spring({
                        clamp: !0,
                        mass: 1,
                        tension: 700,
                        friction: 25,
                        velocity: r.getCurrentVelocities()?.pos || 0,
                        restDelta: 1,
                        restSpeed: 1,
                      })
                      .from({ pos: z })
                      .to({ pos: u })
                      .start());
                })
                .on('panstart', (e) => {
                  !1 !== U('gestures', e) && e?.axis === (O ? 'y' : 'x') && y(S, 'is-dragging');
                })
                .on('panend', (e) => {
                  !1 !== U('gestures', e) && v(S, 'is-dragging');
                })
                .on('end', (e) => {
                  if (!1 === U('gestures', e)) return;
                  let { srcEvent: t, axis: n, velocityX: o, velocityY: i, currentTouch: l } = e;
                  if (l.length > 0 || !r) return;
                  let a = d(t.target),
                    s = a ? (a.scrollHeight > a.clientHeight ? 'y' : 'x') : void 0,
                    c = a && (!n || n === s);
                  O && j(t) && !e.axis && eT(t);
                  let u = Z.length,
                    f = U('dragFree');
                  if (!u) return;
                  let g = c ? 0 : U('vertical') ? i : o,
                    m = r?.isRunning() ? r.getEndValues().pos : z,
                    h = C && !O ? 1 : -1;
                  if ((c || (m += g * (f ? 5 : 1) * h), !R && ((g * h <= 0 && m < F) || (g * h >= 0 && m > H)))) {
                    let e = 0;
                    (Math.abs(g) > 0 && (e = Math.min(0.3 * T, (e = 2 * Math.abs(g)))),
                      (m = p(F + -1 * e, m, H + e)),
                      r
                        .spring({
                          clamp: !0,
                          mass: 1,
                          tension: 380,
                          friction: 25,
                          velocity: -1 * g,
                          restDelta: 1,
                          restSpeed: 1,
                        })
                        .from({ pos: z })
                        .to({ pos: m })
                        .start());
                    return;
                  }
                  if (f || M.Autoscroll?.isEnabled())
                    return void (Math.abs(g) > 10
                      ? r
                          .spring({
                            clamp: !0,
                            mass: 1,
                            tension: 150,
                            friction: 25,
                            velocity: -1 * g,
                            restDelta: 1,
                            restSpeed: 1,
                          })
                          .from({ pos: z })
                          .to({ pos: m })
                          .start()
                      : r.isRunning() || k || ((k = !0), ee('settle')));
                  if (
                    !(f || M.Autoscroll?.isEnabled()) &&
                    (!(e.offsetX || e.offsetY) || ('y' === n && !O) || ('x' === n && O))
                  )
                    return void eC(_, { transition: 'tween' });
                  let y = es(m);
                  (Math.abs(g) > 10 && y === _ && (g > 0 ? (y += C && !O ? 1 : -1) : (y += C && !O ? -1 : 1)),
                    eC(y, { transition: 'tween', tween: { velocity: -1 * g } }));
                })
                .init()));
        }
        b(S, 'is-draggable', !!i && Z.length > 0);
      }
      function ei(e = '*') {
        let t = [];
        for (let n of q)
          ('*' === e || (n.class && n.class.includes(e)) || (n.el && n.el?.classList.contains(e))) && t.push(n);
        ((f = void 0), (D = e), (N = [...t]));
      }
      function er() {
        if (!r) return;
        let e = es(r?.isRunning() ? r.getEndValues().pos : z);
        e !== _ && ((f = _), (_ = e), eR(), el(), ea(), ee('change', _, f));
      }
      function el() {
        if (!L) return;
        for (let e of L.querySelectorAll('[data-carousel-index]')) e.innerHTML = _ + '';
        for (let e of L.querySelectorAll('[data-carousel-page]')) e.innerHTML = _ + 1 + '';
        for (let e of L.querySelectorAll('[data-carousel-pages]')) e.innerHTML = Z.length + '';
        for (let e of L.querySelectorAll('[data-carousel-go-to]'))
          parseInt(e.dataset?.carouselGoTo || '-1', 10) === _
            ? e.setAttribute('aria-current', 'true')
            : e.removeAttribute('aria-current');
        for (let e of L.querySelectorAll('[data-carousel-go-prev]'))
          (e.toggleAttribute('aria-disabled', !ek()),
            ek() ? e.removeAttribute('tabindex') : e.setAttribute('tabindex', '-1'));
        for (let e of L.querySelectorAll('[data-carousel-go-next]'))
          (e.toggleAttribute('aria-disabled', !e_()),
            e_() ? e.removeAttribute('tabindex') : e.setAttribute('tabindex', '-1'));
        let e = !1,
          t = Z[_]?.slides[0];
        for (let n of (t && (t.downloadSrc || ('image' === t.type && t.src)) && (e = !0),
        L.querySelectorAll('[data-carousel-download]')))
          n.toggleAttribute('aria-disabled', !e);
      }
      function ea(e) {
        e || (e = Z[_]?.slides[0]);
        let t = e?.el;
        if (t) for (let n of t.querySelectorAll('[data-slide-index]')) n.innerHTML = e.index + 1 + '';
      }
      function es(e) {
        if (!Z.length) return 0;
        let t = ec(),
          n = e;
        R ? (n -= Math.floor((e - Z[0]?.pos) / t) * t || 0) : (n = p(Z[0]?.pos, e, Z[Z.length - 1]?.pos));
        let o = new Map(),
          i = 0;
        for (let e of Z) {
          let r = Math.min(Math.abs(e.pos - n), Math.abs(e.pos - n - t), Math.abs(e.pos - n + t));
          (o.set(i, r), i++);
        }
        return parseInt((o.size > 0 ? [...o.entries()].reduce((e, t) => (t[1] < e[1] ? t : e)) : [_, 0])[0]);
      }
      function ec(e = !0) {
        return N.length ? N.reduce((e, t) => e + t.dim, 0) + (N.length - (R && e ? 0 : 1)) * Y : 0;
      }
      function eu(e) {
        let t = ec(),
          n = T;
        if (!t || !S || !n) return [];
        let o = [];
        ((e = void 0 === e ? z : e), R && (e -= Math.floor(e / t) * t || 0));
        let i = 0;
        for (let r of N) {
          let l = (t = 0) => {
            !(o.indexOf(r) > -1) &&
              ((r.pos = i - e + t || 0),
              r.offset + t > e - r.dim - P + 0.51 && r.offset + t < e + n + A - 0.51 && o.push(r));
          };
          ((r.offset = i), R && (l(t), l(-1 * t)), l(), (i += r.dim + Y));
        }
        return o;
      }
      function ed(e, t) {
        let n = [];
        for (let t of Array.isArray(e) ? e : [e]) {
          let e = ef({ ...t, isVirtual: !0 });
          (e.el || (e.el = document.createElement('div')), ee('createSlide', e), n.push(e));
        }
        for (let e of (q.splice(void 0 === t ? q.length : t, 0, ...n), ew(), n))
          (ee('addSlide', e),
            (function (e) {
              let t = e.el;
              if (!e || !t) return;
              let n = e.html ? (e.html instanceof HTMLElement ? e.html : c(e.html)) : void 0;
              n && (y(n, 'f-html'), (e.htmlEl = n), y(t, 'has-html'), t.append(n), ee('contentReady', e));
            })(e));
        return (ei(D), n);
      }
      function ef(e) {
        return (
          (a(e) || e instanceof HTMLElement) && (e = { html: e }),
          { index: -1, el: void 0, class: '', isVirtual: !0, dim: 0, pos: 0, offset: 0, html: '', src: '', ...e }
        );
      }
      function em(e) {
        if (!S || !e) return;
        let t = e.el;
        if (t) {
          if ((t.setAttribute('index', e.index + ''), t.parentElement !== S)) {
            let n;
            for (let o of (y(t, x.classes.slide), y(t, e.class), eR(e), q))
              if (o.index > e.index) {
                n = o.el;
                break;
              }
            (S.insertBefore(t, n && S.contains(n) ? n : null), ee('attachSlideEl', e));
          }
          return (ea(e), t);
        }
      }
      function ey(e) {
        let t = e?.el;
        t && (t.remove(), eM(t), ee('detachSlideEl', e));
      }
      function ew() {
        for (let e = 0; e < q.length; e++) {
          let t = q[e],
            n = t.el;
          (n && (t.index !== e && eM(n), n.setAttribute('index', `${e}`)), (t.index = e));
        }
      }
      function ex() {
        if (!L || !S) return;
        ((C = U('rtl')), (I = (O = U('vertical')) ? 'height' : 'width'));
        let e = U('classes');
        if (
          (b(L, e.isLTR, !C),
          b(L, e.isRTL, C),
          b(L, e.isHorizontal, !O),
          b(L, e.isVertical, O),
          b(L, e.hasAdaptiveHeight, U('adaptiveHeight')),
          (T = 0),
          (P = 0),
          (A = 0),
          (Y = 0),
          S)
        ) {
          S.childElementCount || (S.style.display = 'grid');
          let e = S.getBoundingClientRect();
          T = S.getBoundingClientRect()[I] || 0;
          let t = window.getComputedStyle(S);
          ((Y = parseFloat(t.getPropertyValue('--f-carousel-gap')) || 0),
            'visible' === t.getPropertyValue('overflow-' + (O ? 'y' : 'x')) &&
              ((P = Math.abs(e[O ? 'top' : 'left'])),
              (A = Math.abs(window[O ? 'innerHeight' : 'innerWidth'] - e[O ? 'bottom' : 'right']))),
            (S.style.display = ''));
        }
        if (!T) return;
        let t = (function () {
          let e = 0;
          if (S) {
            let t = document.createElement('div');
            ((t.style.display = 'block'),
              y(t, x.classes.slide),
              S.appendChild(t),
              (e = t.getBoundingClientRect()[I]),
              t.remove(),
              (t = void 0));
          }
          return e;
        })();
        for (let e of N) {
          let n = e.el,
            o = 0;
          if (!e.isVirtual && n && s(n)) {
            let e = !1;
            ((n.parentElement && n.parentElement === S) || (S.appendChild(n), (e = !0)),
              (o = n.getBoundingClientRect()[I]),
              e && n.parentElement?.removeChild(n));
          } else o = t;
          e.dim = o;
        }
        if (((R = !1), U('infinite'))) {
          R = !0;
          let e = ec(),
            t = T + P + A;
          for (let n = 0; n < N.length; n++) {
            let o = N[n]?.dim + Y;
            if (e - o < t && e - o - t < o) {
              R = !1;
              break;
            }
          }
        }
        if (
          (!(function () {
            let e;
            if (!L) return;
            let t = T,
              n = ec(!1),
              o = U('slidesPerPage');
            ((o = 'auto' === o ? 1 / 0 : parseFloat(o + '')), (Z = []));
            let i = 0,
              r = 0;
            for (let e of N)
              ((!Z.length || i + e.dim - t > 0.05 || r >= o) &&
                (Z.push({ index: Z.length, slides: [], dim: 0, offset: 0, pos: 0 }), (i = 0), (r = 0)),
                Z[Z.length - 1]?.slides.push(e),
                (i += e.dim + Y),
                r++);
            let l = U('center'),
              a = U('fill'),
              s = 0;
            for (let e of Z) {
              for (let t of ((e.dim = (e.slides.length - 1) * Y), e.slides)) e.dim += t.dim;
              ((e.offset = s),
                (e.pos = s),
                !1 !== l && (e.pos -= (t - e.dim) * 0.5),
                a && !R && n > t && (e.pos = p(0, e.pos, n - t)),
                (s += e.dim + Y));
            }
            let c = [];
            for (let t of Z) {
              let n = { ...t };
              e && 0.1 > Math.abs(n.pos - e.pos)
                ? ((e.dim += n.dim), (e.slides = [...e.slides, ...n.slides]))
                : ((e = n), (n.index = c.length), c.push(n));
            }
            _ = p(0, _, (Z = c).length - 1);
          })(),
          (F = Z[0]?.pos || 0),
          (H = Z[Z.length - 1]?.pos || 0),
          E === eh.Init)
        ) {
          let e;
          ((f = void 0),
            (_ = U('initialPage')),
            void 0 !== (e = U('initialSlide') || void 0) && (_ = e$.getPageIndex(e) || 0),
            (_ = p(0, _, Z.length - 1)),
            ($ = z = Z[_]?.pos || 0));
        } else $ = Z[_ || 0]?.pos || 0;
        (ee('refresh'), el());
      }
      function eM(e) {
        if (!e || !s(e)) return;
        let t = parseInt(e.getAttribute('index') || '-1'),
          n = '';
        for (let t of Array.from(e.classList)) {
          let e = t.match(/^f-(\w+)(Out|In)$/);
          e && e[1] && (n = e[1] + '');
        }
        if (!e || !n) return;
        let o = [`f-${n}Out`, `f-${n}In`, 'to-prev', 'to-next', 'from-prev', 'from-next'];
        (e.removeEventListener('animationend', eS), v(e, o.join(' ')), B.delete(t));
      }
      function eL() {
        if (!S) return;
        let e = B.size > 0;
        for (let e of N) eM(e.el);
        (B.clear(), e && eI());
      }
      function eS(e) {
        e.animationName?.substring(0, 2) === 'f-' &&
          (eM(e.target),
          !B.size && (v(L, 'in-transition'), !k && 0.5 > Math.abs(e$.getPosition(!0) - $) && ((k = !0), ee('settle'))),
          eI());
      }
      function eT(e) {
        if (e.defaultPrevented) return;
        let t = e.composedPath()[0];
        if (t.closest('[data-carousel-go-prev]')) {
          (ep(e), e$.prev());
          return;
        }
        if (t.closest('[data-carousel-go-next]')) {
          (ep(e), e$.next());
          return;
        }
        let n = t.closest('[data-carousel-go-to]');
        if (n) {
          (ep(e), e$.goTo(parseFloat(n.dataset.carouselGoTo || '') || 0));
          return;
        }
        if (t.closest('[data-carousel-download]')) {
          ep(e);
          let t = Z[_]?.slides[0];
          if (t && (t.downloadSrc || ('image' === t.type && t.src))) {
            let e = t.downloadFilename,
              n = document.createElement('a'),
              o = t.downloadSrc || t.src || '';
            ((n.href = o), (n.target = '_blank'), (n.download = e || o), n.click());
          }
          return;
        }
        ee('click', e);
      }
      function eP(e) {
        let t = e.el;
        t && t.querySelector('.f-spinner')?.remove();
      }
      function eA(e) {
        let t = e.el;
        t && (t.querySelector('.f-html.is-error')?.remove(), v(t, 'has-error'));
      }
      function eR(e) {
        e || (e = Z[_]?.slides[0]);
        let t = e?.el;
        if (!t) return;
        let n = U('formatCaption', e);
        (void 0 === n && (n = e.caption), (n = n || ''));
        let o = U('captionEl');
        if (o && o instanceof HTMLElement) {
          if (e.index !== _) return;
          if ((a(n) && (o.innerHTML = K(n + '')), n instanceof HTMLElement)) {
            if (n.parentElement === o) return;
            ((o.innerHTML = ''), n.parentElement && (n = n.cloneNode(!0)), o.append(n));
          }
          return;
        }
        if (!n) return;
        let i = e.captionEl || t.querySelector('.f-caption');
        (!i && n instanceof HTMLElement && n.classList.contains('f-caption') && (i = n),
          !i &&
            (y((i = document.createElement('div')), 'f-caption'),
            a(n)
              ? (i.innerHTML = K(n + ''))
              : n instanceof HTMLElement && (n.parentElement && (n = n.cloneNode(!0)), i.append(n))));
        let r = `f-caption-${eb}_${e.index}`;
        (i.setAttribute('id', r),
          (i.dataset.selectable = 'true'),
          y(t, 'has-caption'),
          t.setAttribute('aria-labelledby', r),
          (e.captionEl = i),
          t.insertAdjacentElement('beforeend', i));
      }
      function eC(e, t = {}) {
        let { transition: n, tween: o } = { ...{ transition: x.transition, tween: x.tween }, ...(t || {}) };
        if (!L || !r) return;
        let i = Z.length;
        if (
          !i ||
          (function (e, t) {
            if (!L || !T || !r || !t || !a(t) || 'tween' === t) return !1;
            for (let e of W) if (T - e.dim > 0.5) return !1;
            if (P > 0.5 || A > 0.5) return;
            let n = Z.length,
              o = e > _ ? 1 : -1;
            ((e = R ? ((e % n) + n) % n : p(0, e, n - 1)), C && (o *= -1));
            let i = Z[_]?.slides[0],
              l = i?.index,
              s = Z[e]?.slides[0],
              c = s?.index,
              u = Z[e]?.pos;
            if (void 0 === c || void 0 === l || l === c || z === u || Math.abs(T - (s?.dim || 0)) > 1) return !1;
            ((k = !1), r.pause(), eL(), y(L, 'in-transition'), (z = $ = u));
            let d = em(i),
              f = em(s);
            return (
              er(),
              d &&
                (B.add(l),
                (d.style.transform = ''),
                d.addEventListener('animationend', eS),
                v(d, x.classes.isSelected),
                (d.inert = !1),
                y(d, `f-${t}Out to-${o > 0 ? 'next' : 'prev'}`)),
              f &&
                (B.add(c),
                (f.style.transform = ''),
                f.addEventListener('animationend', eS),
                y(f, x.classes.isSelected),
                (f.inert = !1),
                y(f, `f-${t}In from-${o > 0 ? 'prev' : 'next'}`)),
              eI(),
              !0
            );
          })(e, n)
        )
          return;
        ((e = R ? ((e % i) + i) % i : p(0, e, i - 1)), ($ = Z[e || 0]?.pos || 0));
        let s = r.isRunning() ? r.getEndValues().pos : z;
        if (1 > Math.abs($ - s)) {
          ((z = $),
            _ !== e && (eR(), (f = _), (_ = e), el(), ea(), ee('change', _, f)),
            eI(),
            k || ((k = !0), ee('settle')));
          return;
        }
        if ((r.pause(), eL(), R)) {
          let e = ec(),
            t = Math.floor((s - Z[0]?.pos) / e) || 0,
            n = $ + t * e,
            o = n - e;
          $ = [n + e, n, o].reduce(function (e, t) {
            return Math.abs(t - s) < Math.abs(e - s) ? t : e;
          });
        }
        !1 !== n && l(o)
          ? r
              .spring(g({}, x.tween, o))
              .from({ pos: z })
              .to({ pos: $ })
              .start()
          : ((z = $), er(), eI(), k || ((k = !0), ee('settle')));
      }
      function eO(e) {
        let t = z;
        if (R && !0 !== e) {
          let e = ec();
          t -= (Math.floor((z - Z[0]?.pos || 0) / e) || 0) * e;
        }
        return t;
      }
      function eI() {
        let e;
        if (!L || !S) return;
        W = eu();
        let t = new Set(),
          n = [],
          o = Z[_],
          i = x.setTransform;
        for (let i of N) {
          let r = B.has(i.index),
            l = W.indexOf(i) > -1,
            a = o?.slides?.indexOf(i) > -1;
          if (i.isVirtual && !r && !l) continue;
          let s = em(i);
          if (s && (n.push(i), a && t.add(s), U('adaptiveHeight') && a)) {
            let t = (s.firstElementChild || s).getBoundingClientRect().height;
            e = void 0 == e ? t : Math.max(e, t);
          }
        }
        (S && e && (S.style.height = `${e}px`),
          [...eg(S, `.${x.classes.slide}`)].forEach((e) => {
            b(e, x.classes.isSelected, t.has(e));
            let n = q[parseInt(e.getAttribute('index') || '-1')];
            if (!n) {
              (e.remove(), eM(e));
              return;
            }
            let o = B.has(n.index),
              r = W.indexOf(n) > -1;
            if (n.isVirtual && !o && !r) return void ey(n);
            if (((e.inert = !r), !1 === i)) return;
            let l = n.pos ? Math.round(1e4 * n.pos) / 1e4 : 0,
              a = 0,
              s = 0,
              c = 0,
              u = 0;
            (o ||
              ((a = O ? 0 : C ? -1 * l : l),
              (s = O ? l : 0),
              (c = h(a, 0, n.dim, 0, 100)),
              (u = h(s, 0, n.dim, 0, 100))),
              i instanceof Function && !o
                ? i(e$, n, { x: a, y: s, xPercent: c, yPercent: u })
                : (e.style.transform = a || s ? `translate3d(${c}%, ${u}%,0)` : ''));
          }),
          ee('render', n));
      }
      function ez() {
        for (let e of (L?.removeEventListener('click', eT),
        document.removeEventListener('mousemove', en),
        B.clear(),
        u?.disconnect(),
        (u = void 0),
        q)) {
          let t = e.el;
          t &&
            s(t) &&
            ((e.state = void 0),
            eP(e),
            eA(e),
            e.isVirtual
              ? (ey(e), (e.el = void 0))
              : (eM(t), (t.style.transform = ''), S && !S.contains(t) && S.appendChild(t)));
        }
        for (let e of Object.values(M)) e?.destroy();
        for (let [e, t] of ((M = {}),
        i?.destroy(),
        (i = void 0),
        r?.destroy(),
        (r = void 0),
        Object.entries(x.classes || {})))
          'container' !== e && v(L, t);
        v(S, 'is-draggable');
      }
      function ek() {
        return R || _ > 0;
      }
      function e_() {
        return R || _ < Z.length - 1;
      }
      let e$ = {
        add: function (e, t) {
          let n = z,
            o = _,
            i = ec(),
            l = r?.isRunning() ? r.getEndValues().pos : z,
            a = (i && Math.floor((l - (Z[0]?.pos || 0)) / i)) || 0;
          return (
            ed(e, t),
            ei(D),
            ex(),
            r &&
              i &&
              (o === _ && (n -= a * i),
              n === $
                ? (z = $)
                : r
                    .spring({ clamp: !0, mass: 1, tension: 300, friction: 25, restDelta: 1, restSpeed: 1 })
                    .from({ pos: n })
                    .to({ pos: $ })
                    .start()),
            eI(),
            e$
          );
        },
        canGoPrev: ek,
        canGoNext: e_,
        destroy: function () {
          return (
            ee('destroy'),
            window.removeEventListener('resize', et),
            ez(),
            J.clear(),
            (L = null),
            (Z = []),
            (q = []),
            (x = { ...ev }),
            (M = {}),
            (N = []),
            (m = void 0),
            (D = '*'),
            (E = eh.Destroyed),
            e$
          );
        },
        emit: ee,
        filter: function (e = '*') {
          return (ei(e), ex(), (z = p(F, z, H)), eI(), ee('filter', e), e$);
        },
        getContainer: function () {
          return L;
        },
        getGapDim: function () {
          return Y;
        },
        getGestures: function () {
          return i;
        },
        getLastMouseMove: function () {
          return n;
        },
        getOption: function (e) {
          return U(e);
        },
        getOptions: function () {
          return x;
        },
        getPage: function () {
          return Z[_];
        },
        getPageIndex: function (e) {
          if (void 0 !== e) {
            for (let t of Z || []) for (let n of t.slides) if (n.index === e) return t.index;
            return -1;
          }
          return _;
        },
        getPageIndexFromPosition: es,
        getPageProgress: function (e, t) {
          void 0 === e && (e = _);
          let n = Z[e];
          if (!n) return e > _ ? -1 : 1;
          let o = ec(),
            i = Y,
            r = n.pos,
            l = eO();
          if (R && !0 !== t) {
            let e = Math.floor((l - Z[0]?.pos) / o) || 0;
            ((l -= e * o),
              (r = [r + o, r, r - o].reduce(function (e, t) {
                return Math.abs(t - l) < Math.abs(e - l) ? t : e;
              })));
          }
          return (l - r) / (n.dim + i) || 0;
        },
        getPageVisibility: function (e) {
          void 0 === e && (e = _);
          let t = Z[e];
          if (!t) return e > _ ? -1 : 1;
          let n = eO(),
            o = T,
            i = t.pos;
          if (R) {
            let e = ec(),
              t = i + (Math.floor((n - Z[0]?.pos) / e) || 0) * e,
              o = t - e;
            i = [t + e, t, o].reduce(function (e, t) {
              return Math.abs(t - n) < Math.abs(e - n) ? t : e;
            });
          }
          return i > n && i + t.dim < n + o
            ? 1
            : i < n
              ? (i + t.dim - n) / t.dim || 0
              : (i + t.dim > n + o && (n + o - i) / t.dim) || 0;
        },
        getPages: function () {
          return Z;
        },
        getPlugins: function () {
          return M;
        },
        getPosition: eO,
        getSlides: function () {
          return q;
        },
        getState: function () {
          return E;
        },
        getTotalSlideDim: ec,
        getTween: function () {
          return r;
        },
        getViewport: function () {
          return S;
        },
        getViewportDim: function () {
          return T;
        },
        getVisibleSlides: function (e) {
          return void 0 === e ? W : eu(e);
        },
        goTo: eC,
        hasNavigated: function () {
          return void 0 !== f;
        },
        hideError: eA,
        hideLoading: eP,
        init: function () {
          if (!e || !s(e)) throw Error('No Element found');
          return (
            E !== eh.Init && (ez(), (E = eh.Init)),
            (L = e),
            (w = t),
            window.removeEventListener('resize', et),
            w.breakpoints && window.addEventListener('resize', et),
            et(),
            e$
          );
        },
        isInfinite: function () {
          return R;
        },
        isInTransition: function () {
          return B.size > 0;
        },
        isRTL: function () {
          return C;
        },
        isSettled: function () {
          return k;
        },
        isVertical: function () {
          return O;
        },
        localize: function (e, t = []) {
          return K(e, t);
        },
        next: function (e = {}) {
          return (eC(_ + 1, e), e$);
        },
        off: function (e, t) {
          for (let n of e instanceof Array ? e : [e])
            J.has(n) &&
              J.set(
                n,
                J.get(n).filter((e) => e !== t),
              );
          return e$;
        },
        on: function (e, t) {
          for (let n of e instanceof Array ? e : [e]) J.set(n, [...(J.get(n) || []), t]);
          return e$;
        },
        prev: function (e = {}) {
          return (eC(_ - 1, e), e$);
        },
        reInit: function (e = {}, n) {
          return (ez(), (E = eh.Init), (m = void 0), (D = '*'), (t = e), (w = e), l(n) && (o = n), et(), e$);
        },
        remove: function (e) {
          void 0 === e && (e = q.length - 1);
          let t = q[e];
          return (
            t &&
              (ee('removeSlide', t),
              t.el && (eM(t.el), t.el.remove(), (t.el = void 0)),
              q.splice(e, 1),
              ei(D),
              ex(),
              (z = p(F, z, H)),
              eI()),
            e$
          );
        },
        setPosition: function (e) {
          ((z = e), er(), eI());
        },
        showError: function (e, t) {
          (eP(e), eA(e));
          let n = e.el;
          if (n) {
            let o = document.createElement('div');
            (y(o, 'f-html'),
              y(o, 'is-error'),
              (o.innerHTML = K(t || '<p>{{ERROR}}</p>')),
              (e.htmlEl = o),
              y(n, 'has-html'),
              y(n, 'has-error'),
              n.insertAdjacentElement('afterbegin', o),
              ee('contentReady', e));
          }
          return e$;
        },
        showLoading: function (e) {
          let t = e.el,
            n = t?.querySelector('.f-spinner');
          if (!t || n) return e$;
          let o = c(U('spinnerTpl'));
          return (o && (y(o, 'f-spinner'), t.insertAdjacentElement('beforeend', o)), e$);
        },
        version: '6.1.6',
      };
      return e$;
    };
  ((eE.l10n = { en_EN: em }), (eE.getDefaults = () => ev));
  let ew = function (e = '', t = '', n = '') {
      return e.split(t).join(n);
    },
    ex = {
      tpl: (e) => `<img class="f-panzoom__content" 
    ${e.srcset ? 'data-lazy-srcset="{{srcset}}"' : ''} 
    ${e.sizes ? 'data-lazy-sizes="{{sizes}}"' : ''} 
    data-lazy-src="{{src}}" alt="{{alt}}" />`,
    },
    eM = () => {
      let e;
      function t(t, n) {
        let o = e?.getOptions().Zoomable,
          i = (l(o) ? { ...ex, ...o } : ex)[t];
        return i && 'function' == typeof i && n ? i(n) : i;
      }
      function n() {
        e &&
          !1 !== e.getOptions().Zoomable &&
          (e.on('addSlide', r),
          e.on('removeSlide', s),
          e.on('attachSlideEl', c),
          e.on('click', i),
          e.on('change', o),
          e.on('ready', o));
      }
      function o() {
        u();
        let t = e?.getVisibleSlides() || [];
        if (t.length > 1 || e?.getOption('transition') === 'slide')
          for (let n of t) {
            let t = n.panzoomRef;
            t && 0 > (e?.getPage().slides || []).indexOf(n) && t.execute(ei.ZoomTo, { ...t.getStartPosition() });
          }
      }
      function i(e, t) {
        let n = t.target;
        n && !t.defaultPrevented && n.dataset.panzoomAction && d(n.dataset.panzoomAction);
      }
      function r(n, o) {
        let i = o.el;
        if (!e || !i || o.panzoomRef) return;
        let r = o.src || o.lazySrc || '',
          l = o.alt || o.caption || `Image #${o.index}`,
          s = o.srcset || o.lazySrcset || '',
          c = o.sizes || o.lazySizes || '';
        if (r && a(r) && !o.html && (!o.type || 'image' === o.type)) {
          ((o.type = 'image'), (o.thumbSrc = o.thumbSrc || r));
          let e = t('tpl', o);
          ((e = ew(e, '{{src}}', r + '')),
            (e = ew(e, '{{srcset}}', s + '')),
            (e = ew(e, '{{sizes}}', c + '')),
            i.insertAdjacentHTML('afterbegin', e));
        }
        let d = i.querySelector('.f-panzoom__content');
        if (!d) return;
        d.setAttribute('alt', l + '');
        let f = ef(i, {
          width: o.width && 'auto' !== o.width ? parseFloat(o.width + '') : 'auto',
          height: o.height && 'auto' !== o.height ? parseFloat(o.height + '') : 'auto',
          classes: { container: 'f-zoomable' },
          event: () => e?.getLastMouseMove(),
          spinnerTpl: () => e?.getOption('spinnerTpl') || '',
          ...t('Panzoom'),
        });
        (f.on('*', (t, n, ...i) => {
          e &&
            ('loading' === n && (o.state = 0),
            'loaded' === n && (o.state = 1),
            'error' === n && ((o.state = 2), e?.showError(o, '{{IMAGE_ERROR}}')),
            e.emit(`panzoom:${n}`, o, ...i),
            'ready' === n && e.emit('contentReady', o),
            o.index === e?.getPageIndex() && u());
        }),
          (o.panzoomRef = f));
      }
      function s(e, t) {
        t.panzoomRef && (t.panzoomRef.destroy(), (t.panzoomRef = void 0));
      }
      function c(e, t) {
        let n = t.panzoomRef;
        if (n)
          switch (n.getState()) {
            case ea.Init:
              n.init();
              break;
            case ea.Ready:
              n.execute(ei.ZoomTo, { ...n.getStartPosition(), velocity: 0 });
          }
      }
      function u() {
        let t = e?.getContainer() || void 0,
          n = e?.getPage()?.slides[0]?.panzoomRef;
        if (t)
          if (n) n.updateControls(t);
          else
            for (let e of t.querySelectorAll('[data-panzoom-action]') || [])
              (e.setAttribute('aria-disabled', ''), e.setAttribute('tabindex', '-1'));
      }
      function d(t, ...n) {
        e?.getPage().slides[0].panzoomRef?.execute(t, ...n);
      }
      return {
        init: function (t) {
          (e = t).on('initPlugins', n);
        },
        destroy: function () {
          if (e)
            for (let t of (e.off('initPlugins', n),
            e.off('addSlide', r),
            e.off('removeSlide', s),
            e.off('attachSlideEl', c),
            e.off('click', i),
            e.off('change', o),
            e.off('ready', o),
            e.getSlides()))
              s(e, t);
          e = void 0;
        },
        execute: d,
      };
    },
    eL = { syncOnChange: !1, syncOnClick: !0, syncOnHover: !1 },
    eS = () => {
      let e, t;
      function n() {
        let t = e?.getOptions().Sync;
        return l(t) ? { ...eL, ...t } : eL;
      }
      function o() {
        let o = n().target;
        e &&
          o &&
          e &&
          o &&
          ((t = o),
          (e.getOptions().classes = { ...e.getOptions().classes, isSelected: '' }),
          (e.getOptions().initialSlide = t.getPage()?.slides[0]?.index || 0),
          n().syncOnChange && e.on('change', r),
          n().syncOnClick && e.on('click', s),
          n().syncOnHover && e.getViewport()?.addEventListener('mouseover', c),
          e && t && (e.on('ready', i), e.on('refresh', u), t.on('change', a), t.on('filter', d)));
      }
      function i() {
        f();
      }
      function r() {
        if (e && t) {
          let n = e.getPage()?.slides || [],
            o = t.getPageIndex(n[0].index || 0);
          (o > -1 && t.goTo(o, e.hasNavigated() ? void 0 : { tween: !1, transition: !1 }), f());
        }
      }
      function a() {
        if (e && t) {
          let n = e.getPageIndex(t.getPage()?.slides[0].index || 0);
          (n > -1 && e.goTo(n, t.hasNavigated() ? void 0 : { tween: !1, transition: !1 }), f());
        }
      }
      function s(n, o) {
        if (!e || !t || e.getTween()?.isRunning()) return;
        let i = e?.getOptions().classes.slide;
        if (!i) return;
        let r = i ? o.target.closest(`.${i}`) : null;
        if (r) {
          let e = parseInt(r.getAttribute('index') || '') || 0,
            n = t.getPageIndex(e);
          t.goTo(n);
        }
      }
      function c(t) {
        e && s(e, t);
      }
      function u() {
        if (e && t) {
          let n = e.getPageIndex(t.getPage()?.slides[0].index || 0);
          (n > -1 && e.goTo(n, { tween: !1, transition: !1 }), f());
        }
      }
      function d(n, o) {
        e && t && (e.filter(o), a());
      }
      function f() {
        if (!t) return;
        let n = t.getPage()?.slides[0]?.index || 0;
        for (let t of e?.getSlides() || []) t.el?.classList.toggle('is-selected', t.index === n);
      }
      return {
        init: function (t) {
          (e = t).on('initSlides', o);
        },
        destroy: function () {
          (e?.off('ready', i),
            e?.off('refresh', u),
            e?.off('change', r),
            e?.off('click', s),
            e?.getViewport()?.removeEventListener('mouseover', c),
            t?.off('change', a),
            t?.off('filter', d),
            (t = void 0),
            e?.off('initSlides', o),
            (e = void 0));
        },
        getTarget: function () {
          return t;
        },
      };
    },
    eT = { showLoading: !0, preload: 1 },
    eP = 'is-lazyloading',
    eA = 'is-lazyloaded',
    eR = 'has-lazyerror',
    eC = () => {
      let e;
      function t() {
        let t = e?.getOptions().Lazyload;
        return l(t) ? { ...eT, ...t } : eT;
      }
      function n() {
        if (!e) return;
        let n = [...e.getVisibleSlides()],
          o = t().preload;
        if (o > 0) {
          let t = e.getPosition(),
            i = e.getViewportDim();
          n.push(...e.getVisibleSlides(t + i * o), ...e.getVisibleSlides(t - i * o));
        }
        for (let o of n)
          !(function (n) {
            let o = n.el;
            if (!o) return;
            let i = '[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]',
              r = Array.from(o.querySelectorAll(i));
            for (let l of (o.matches(i) && r.push(o), r)) {
              let o = l.dataset.lazySrc,
                i = l.dataset.lazySrcset,
                r = l.dataset.lazySizes,
                a = l.dataset.lazyBg,
                s = (l instanceof HTMLImageElement || l instanceof HTMLSourceElement) && (o || i),
                c = l instanceof HTMLElement && a;
              if (!(s || c)) continue;
              let u = o || i || a;
              if (u) {
                if (s && u) {
                  let a = l.parentElement?.classList.contains('f-panzoom__wrapper');
                  (t().showLoading && e?.showLoading(n),
                    l.addEventListener('load', () => {
                      (e?.hideLoading(n),
                        v(l, eR),
                        l instanceof HTMLImageElement
                          ? l.decode().then(() => {
                              (v(l, eP), y(l, eA));
                            })
                          : (v(l, eP), y(l, eA)),
                        a || e?.emit('lazyLoad:loaded', n, l, u));
                    }),
                    l.addEventListener('error', () => {
                      (e?.hideLoading(n), v(l, eP), y(l, eR), a || e?.emit('lazyLoad:error', n, l, u));
                    }),
                    l.classList.add('f-lazyload'),
                    l.classList.add(eP),
                    a || e?.emit('lazyLoad:load', n, l, u),
                    o && (l.src = o),
                    i && (l.srcset = i),
                    r && (l.sizes = r));
                } else
                  c &&
                    (document.body.contains(l) || (document.createElement('img').src = a),
                    (l.style.backgroundImage = `url('${a}')`));
                (delete l.dataset.lazySrc,
                  delete l.dataset.lazySrcset,
                  delete l.dataset.lazySizes,
                  delete l.dataset.lazyBg);
              }
            }
          })(o);
      }
      return {
        init: function (t) {
          (e = t).on('render', n);
        },
        destroy: function () {
          (e?.off('render', n), (e = void 0));
        },
      };
    },
    eO = '<svg width="24" height="24" viewBox="0 0 24 24" tabindex="-1">',
    eI = '</svg>',
    ez = { prevTpl: eO + '<path d="M15 3l-9 9 9 9"></path>' + eI, nextTpl: eO + '<path d="M9 3l9 9-9 9"></path>' + eI },
    ek = () => {
      let e, t, n;
      function o() {
        let t = e?.getOptions().Arrows;
        return l(t) ? { ...ez, ...t } : ez;
      }
      function i(t) {
        if (!e) return;
        let n =
            `<button data-carousel-go-${t} tabindex="0" class="f-button is-arrow is-${t}" title="{{${t.toUpperCase()}}}">` +
            o()[`${t}Tpl`] +
            '</button',
          i = c(e.localize(n)) || void 0;
        return (i && y(i, o()[`${t}Class`]), i);
      }
      function r() {
        (t?.remove(), (t = void 0), n?.remove(), (n = void 0), e?.getContainer()?.classList.remove('has-arrows'));
      }
      function a() {
        e && !1 !== e.getOptions().Arrows && e.getPages().length > 1
          ? (!(function () {
              if (!e) return;
              let o = e.getViewport();
              o &&
                (!t && (t = i('prev')) && o.insertAdjacentElement('beforebegin', t),
                !n && (n = i('next')) && o.insertAdjacentElement('afterend', n),
                b(e.getContainer(), 'has-arrows', !!(t || n)));
            })(),
            e &&
              (t?.toggleAttribute('aria-disabled', !e.canGoPrev()),
              n?.toggleAttribute('aria-disabled', !e.canGoNext())))
          : r();
      }
      return {
        init: function (t) {
          e = t.on(['change', 'refresh'], a);
        },
        destroy: function () {
          (r(), e?.off(['change', 'refresh'], a), (e = void 0));
        },
      };
    },
    e_ = '<circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/>',
    e$ = '<g><line x1="11" y1="8" x2="11" y2="14"></line></g>' + e_,
    eF = {};
  for (let [e, t] of Object.entries({
    moveLeft: ['moveLeft', 'MOVE_LEFT', '<path d="M5 12h14M5 12l6 6M5 12l6-6"/>'],
    moveRight: ['moveRight', 'MOVE_RIGHT', '<path d="M5 12h14M13 18l6-6M13 6l6 6"/>'],
    moveUp: ['moveUp', 'MOVE_UP', '<path d="M12 5v14M18 11l-6-6M6 11l6-6"/>'],
    moveDown: ['moveDown', 'MOVE_DOWN', '<path d="M12 5v14M18 13l-6 6M6 13l6 6"/>'],
    zoomOut: ['zoomOut', 'ZOOM_OUT', e_],
    zoomIn: ['zoomIn', 'ZOOM_IN', e$],
    toggleFull: ['toggleFull', 'TOGGLE_FULL', e$],
    iterateZoom: ['iterateZoom', 'ITERATE_ZOOM', e$],
    toggle1to1: [
      'toggleFull',
      'TOGGLE_FULL',
      '<path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/>',
    ],
    rotateCCW: [
      'rotateCCW',
      'ROTATE_CCW',
      '<path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/>',
    ],
    rotateCW: [
      'rotateCW',
      'ROTATE_CW',
      '<path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/>',
    ],
    flipX: ['flipX', 'FLIP_X', '<path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/>'],
    flipY: ['flipY', 'FLIP_Y', '<path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/>'],
    reset: ['reset', 'RESET', '<path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>'],
    toggleFS: [
      'toggleFS',
      'TOGGLE_FS',
      '<g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g>',
    ],
  }))
    eF[e] = {
      tpl: `<button data-panzoom-action="${t[0]}" class="f-button" title="{{${t[1]}}}"><svg>${t[2]}</svg></button>`,
    };
  let eH = (((z = {}).Left = 'left'), (z.middle = 'middle'), (z.right = 'right'), z),
    eD = {
      counter: {
        tpl: '<div class="f-counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>',
      },
      download: {
        tpl: '<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>',
      },
      autoplay: {
        tpl: '<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>',
      },
      thumbs: {
        tpl: '<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>',
      },
      ...eF,
    },
    eV = {
      absolute: !1,
      display: {
        left: [],
        middle: ['zoomIn', 'zoomOut', 'toggle1to1', 'rotateCCW', 'rotateCW', 'flipX', 'flipY', 'reset'],
        right: [],
      },
      enabled: 'auto',
      items: {},
    },
    ej = () => {
      let e, t;
      function n(t) {
        let n = e?.getOptions().Toolbar,
          o = (l(n) ? { ...eV, ...n } : eV)[t];
        return o && 'function' == typeof o && e ? o(e) : o;
      }
      function o() {
        if (!e?.getOptions().Toolbar || !e || t) return;
        let o = e.getContainer();
        if (!o) return;
        let i = n('enabled');
        if (!i) return;
        let r = n('absolute'),
          s = e.getSlides().length > 1,
          u = !1,
          d = !1;
        for (let t of e.getSlides())
          (t.panzoomRef && (u = !0), (t.downloadSrc || ('image' === t.type && t.src)) && (d = !0));
        let f = e.getPlugins().Thumbs?.isEnabled() || !1,
          m = (s && e.getPlugins().Autoplay) || !1,
          p = e.getPlugins().Fullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled);
        if (('auto' === i && (i = u), !i)) return;
        (t = o.querySelector('.f-carousel__toolbar') || void 0) ||
          (t = document.createElement('div')).classList.add('f-carousel__toolbar');
        let h = n('display'),
          y = g({}, eD, n('items'));
        for (let n of ['left', 'middle', 'right']) {
          let o = h[n] || [],
            i = document.createElement('div');
          for (let t of (i.classList.add('f-carousel__toolbar__column'), i.classList.add(`is-${n}`), o)) {
            let n;
            if (a(t)) {
              if (
                ('counter' === t && !s) ||
                ('autoplay' === t && !m) ||
                (eF[t] && !u) ||
                ('fullscreen' === t && !p) ||
                ('thumbs' === t && !f) ||
                ('download' === t && !d)
              )
                continue;
              n = y[t];
            }
            if ((l(t) && (n = t), n && n.tpl)) {
              let t = e.localize(n.tpl),
                o = c((t = t.split('<svg>').join('<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">')));
              o &&
                ('function' == typeof n.click &&
                  e &&
                  o.addEventListener('click', (t) => {
                    (t.preventDefault(), t.stopPropagation(), 'function' == typeof n.click && e && n.click(e, t));
                  }),
                i.append(o));
            }
          }
          t.append(i);
        }
        if (t.childElementCount) {
          if ((r && t.classList.add('is-absolute'), !t.parentElement)) {
            let o = n('parentEl');
            o ? o.insertAdjacentElement('afterbegin', t) : e.getViewport()?.insertAdjacentElement('beforebegin', t);
          }
          o.contains(t) && o.classList.add('has-toolbar');
        }
      }
      return {
        init: function (t) {
          ((e = t), e?.on('initSlides', o));
        },
        destroy: function () {
          (e?.off('initSlides', o), e?.getContainer()?.classList.remove('has-toolbar'), t?.remove(), (t = void 0));
        },
        add: function (e, t) {
          eD[e] = t;
        },
        isEnabled: function () {
          return !!t;
        },
      };
    },
    eq = { autoStart: !0, pauseOnHover: !0, showProgressbar: !0, timeout: 2e3 },
    eN = () => {
      let e,
        t,
        n = !1,
        o = !1,
        i = !1,
        r = null;
      function a(t) {
        let n = e?.getOptions().Autoplay,
          o = (l(n) ? { ...eq, ...n } : eq)[t];
        return o && 'function' == typeof o && e ? o(e) : o;
      }
      function s() {
        (clearTimeout(t), (t = void 0));
      }
      function c() {
        !e ||
          !n ||
          i ||
          o ||
          t ||
          !e.isSettled() ||
          (function () {
            for (let t of e?.getPage()?.slides || []) if (0 === t.state) return !0;
            return !1;
          })() ||
          ((function () {
            if (!e || (f(), !a('showProgressbar'))) return;
            let t = a('progressbarParentEl');
            if (
              (!t && e.getPlugins().Toolbar?.isEnabled() && (t = e.getContainer()),
              !t && e.getPlugins().Toolbar?.isEnabled() !== !0)
            ) {
              let n = e.getPages()[0]?.slides || [],
                o = e.getPage()?.slides || [];
              1 === n.length && 1 === o.length && (t = o[0].el);
            }
            if ((t || (t = e.getViewport()), !t)) return;
            (y((r = document.createElement('div')), 'f-progressbar'), t.prepend(r));
            let n = a('timeout') || 1e3;
            r.style.animationDuration = `${n}ms`;
          })(),
          (t = setTimeout(() => {
            if (e && n && !o) {
              if (!e.isInfinite() && e.getPageIndex() === e.getPages().length - 1) return void e.goTo(0);
              e.next();
            }
          }, a('timeout'))));
      }
      function u() {
        if (!e || e.getPages().length < 2 || !1 === e.getOptions().Autoplay || n) return;
        ((n = !0),
          e.emit('autoplay:start', a('timeout')),
          y(e.getContainer(), 'has-autoplay'),
          e.getTween()?.on('start', b));
        let t = e?.getContainer();
        (t &&
          a('pauseOnHover') &&
          matchMedia('(hover: hover)').matches &&
          (t.addEventListener('mouseenter', E, !1), t.addEventListener('mouseleave', w, !1)),
          e.on('change', h),
          e.on('settle', v),
          e.on('contentReady', m),
          e.on('panzoom:touchStart', d),
          e.on('panzoom:wheel', d),
          e.isSettled() && c());
      }
      function d() {
        if ((s(), f(), e)) {
          if (n) {
            (e.emit('autoplay:end'), e.getTween()?.off('start', b));
            let t = e.getContainer();
            t &&
              (t.classList.remove('has-autoplay'),
              t.removeEventListener('mouseenter', E, !1),
              t.removeEventListener('mouseleave', w, !1));
          }
          (e.off('change', h),
            e.off('settle', v),
            e.off('contentReady', m),
            e.off('panzoom:touchStart', d),
            e.off('panzoom:wheel', d));
        }
        ((n = !1), (o = !1));
      }
      function f() {
        r && (r.remove(), (r = null));
      }
      function g() {
        e && e.getPages().length > 1 && a('autoStart') && u();
      }
      function m() {
        c();
      }
      function p(e, t) {
        let n = t.target;
        n && !t.defaultPrevented && 'toggle' === n.dataset.autoplayAction && x.toggle();
      }
      function h() {
        e && (e?.isInfinite() || e.getPageIndex() !== e.getPages().length - 1) ? (f(), s()) : d();
      }
      function v() {
        c();
      }
      function b() {
        (s(), f());
      }
      function E() {
        ((i = !0), n && (f(), s()));
      }
      function w() {
        ((i = !1), n && !o && e?.isSettled() && c());
      }
      let x = {
        init: function (t) {
          ((e = t).on('ready', g), e.on('click', p));
        },
        destroy: function () {
          (d(), e?.off('ready', g), e?.off('click', p), (e = void 0));
        },
        isEnabled: () => n,
        pause: function () {
          ((o = !0), s());
        },
        resume: function () {
          ((o = !1), n && !i && c());
        },
        start() {
          u();
        },
        stop() {
          d();
        },
        toggle() {
          n ? d() : u();
        },
      };
      return x;
    },
    eB = {
      Carousel: { Lazyload: { showLoading: !1 } },
      minCount: 2,
      showOnStart: !0,
      thumbTpl:
        '<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>',
      type: 'modern',
    },
    eW = () => {
      let e,
        t,
        n,
        i,
        r,
        a = 0,
        s = 0,
        u = !0;
      function d(t) {
        let n = e?.getOptions().Thumbs,
          o = (l(n) ? { ...eB, ...n } : eB)[t];
        return o && 'function' == typeof o && e ? o(e) : o;
      }
      function f() {
        if (!e || e?.getOptions().Thumbs === !1) return !1;
        let t = 0;
        for (let n of e.getSlides()) n.thumbSrc && t++;
        return t >= d('minCount');
      }
      function m() {
        return 'modern' === d('type');
      }
      function h() {
        return 'scrollable' === d('type');
      }
      function v() {
        let t = [];
        for (let n of e?.getSlides() || []) t.push({ index: n.index, class: n.thumbClass, html: b(n) });
        return t;
      }
      function b(e) {
        let t = e.thumb ? (e.thumb instanceof HTMLImageElement ? e.thumb.src : e.thumb) : e.thumbSrc || void 0,
          n = void 0 === e.thumbAlt ? `Thumbnail #${e.index}` : e.thumbAlt + '',
          o = d('thumbTpl');
        return (
          (o = ew(o, '{{alt}}', n)),
          (o = ew(o, '{{src}}', t + '')),
          (o = ew(o, '{{index}}', `${e.index}`)),
          (o = ew(o, '{{page}}', `${e.index || 1}`))
        );
      }
      function E(e) {
        return `<div index="${e.index || 0}" class="f-thumbs__slide ${e.class || ''}">${e.html || ''}</div>`;
      }
      function w(t = !1) {
        let o = e?.getContainer();
        if (!e || !o || n || !f()) return;
        let i = d('Carousel')?.classes || {};
        if (((i.container = i.container || 'f-thumbs'), !n)) {
          let e = o.nextElementSibling;
          e?.classList.contains(i.container) && (n = e);
        }
        if (!n) {
          n = document.createElement('div');
          let e = d('parentEl');
          e ? e.insertAdjacentElement('beforeend', n) : o.insertAdjacentElement('afterend', n);
        }
        (y(n, i.container), y(n, 'f-thumbs'), y(n, `is-${d('type')}`), t && y(n, 'is-hidden'));
      }
      function x() {
        if (!n || !h()) return;
        y((i = document.createElement('div')), 'f-thumbs__viewport');
        let t = '';
        for (let e of v()) 'string' == typeof (e.html || '') && (t += E(e));
        ((i.innerHTML = t),
          n.append(i),
          n.addEventListener('click', (t) => {
            t.preventDefault();
            let n = t.target.closest('[index]'),
              o = parseInt(n?.getAttribute('index') || '-1');
            e && o > -1 && e.goTo(o);
          }),
          (r = new IntersectionObserver(
            (e) => {
              e.forEach((e) => {
                e.isIntersecting &&
                  e.target instanceof HTMLImageElement &&
                  ((e.target.src = e.target.getAttribute('data-lazy-src') + ''),
                  e.target.removeAttribute('data-lazy-src'),
                  r?.unobserve(e.target));
              });
            },
            { root: i, rootMargin: '100px' },
          )),
          n.querySelectorAll('[data-lazy-src]').forEach((e) => {
            r?.observe(e);
          }),
          e?.emit('thumbs:ready'));
      }
      function M() {
        if (!o || !e || !n || h() || t) return;
        let i = v();
        if (!i.length) return;
        let r = g(
          {},
          {
            Sync: { target: e },
            Lazyload: { preload: 1 },
            slides: i,
            classes: { container: 'f-thumbs', viewport: 'f-thumbs__viewport', slide: 'f-thumbs__slide' },
            center: !0,
            fill: !m(),
            infinite: !1,
            dragFree: !0,
            rtl: e.getOptions().rtl || !1,
            slidesPerPage: (e) => {
              let t = 0;
              return (m() &&
                ((function () {
                  if (!m() || !n) return;
                  let e = (e) => (n && parseFloat(getComputedStyle(n).getPropertyValue('--f-thumb-' + e))) || 0;
                  ((a = e('width')), (s = e('clip-width')));
                })(),
                (t = (a - s) * 4)),
              e && e.getTotalSlideDim() <= e.getViewportDim() - t)
                ? 1 / 0
                : 1;
            },
          },
          eB.Carousel || {},
          d('Carousel') || {},
        );
        ((t = o(n, r, { Sync: eS, Lazyload: eC })).on('ready', () => {
          (y(n, 'is-syncing'), e?.emit('thumbs:ready'), m() && e?.on('render', P));
        }),
          t.on('destroy', () => {
            e?.emit('thumbs:destroy');
          }),
          t.init(),
          t.getGestures()?.on('start', () => {
            u = !1;
          }),
          t.on('click', (e, t) => {
            let n = t.target;
            if (n) {
              let e = n.matches('button') ? n : n.firstElementChild;
              e && e.matches('button') && (t.preventDefault(), e.focus({ preventScroll: !0 }));
            }
          }),
          y(e.getContainer(), 'has-thumbs'),
          k());
      }
      function L() {
        f() && d('showOnStart') && (w(), x());
      }
      function S() {
        f() &&
          (M(),
          e?.on('addSlide', R),
          e?.on('removeSlide', C),
          e?.on('click', O),
          e?.on('refresh', I),
          e?.getGestures()?.on('start', T),
          z(!0));
      }
      function T() {
        ((u = !0), document.activeElement?.closest('.f-thumbs') && document.activeElement?.blur());
      }
      function P() {
        (n?.classList.toggle('is-syncing', e?.hasNavigated() === !1 || e?.getTween()?.isRunning()),
          k(),
          e?.getGestures()?.isPointerDown() &&
            (function () {
              if (!m() || !e || !t || !u) return;
              let n = t.getTween(),
                o = t.getPages(),
                i = e.getPageIndex() || 0,
                r = e.getPageProgress() || 0;
              if (!e || !o || !o[i] || !n) return;
              let l = n.isRunning() ? n.getCurrentValues().pos : t.getPosition();
              if (void 0 === l) return;
              let c = o[i].pos + r * (a - s);
              ((c = p(o[0].pos, c, o[o.length - 1].pos)), n.from({ pos: l }).to({ pos: c }).start());
            })());
      }
      function A() {
        ((u = !0), z());
      }
      function R(e, n) {
        let o = { html: b(n) };
        if (t) t.add(o, n.index);
        else if (i) {
          let e = c(E(o));
          if (e) {
            i.append(e);
            let t = e.querySelector('img');
            t && r?.observe(t);
          }
        }
      }
      function C(e, n) {
        t ? t.remove(n.index) : i && i.querySelector(`[index="${n.index}"]`)?.remove();
      }
      function O(e, t) {
        let o = t.target;
        !t.defaultPrevented &&
          o?.dataset?.thumbsAction === 'toggle' &&
          (n || (w(!0), x(), M()), n && n.classList.toggle('is-hidden'));
      }
      function I() {
        z();
      }
      function z(t = !1) {
        if (!e || !i || !h()) return;
        let n = e.getPageIndex();
        i.querySelectorAll('.is-selected').forEach((e) => {
          e.classList.remove('is-selected');
        });
        let o = i.querySelector(`[index="${n}"]`);
        if (o) {
          o.classList.add('is-selected');
          let e = i.getBoundingClientRect(),
            n = o.getBoundingClientRect(),
            r = o.offsetTop - i.offsetTop - 0.5 * e.height + 0.5 * n.height,
            l = o.scrollLeft - i.scrollLeft - 0.5 * e.width + 0.5 * n.width;
          i.scrollTo({ top: r, left: l, behavior: t ? 'instant' : 'smooth' });
        }
      }
      function k() {
        if (!m() || !e || !t) return;
        let n = t?.getSlides() || [],
          o = -0.5 * a;
        for (let t of n) {
          let n = t.el;
          if (!n) continue;
          let i = e.getPageProgress(t.index) || 0;
          ((i = Math.max(-1, Math.min(1, i))) > -1 && i < 1 && (o += 0.5 * a * (1 - Math.abs(i))),
            (i = Math.round(1e4 * i) / 1e4),
            (o = Math.round(1e4 * o) / 1e4),
            n.style.setProperty('--progress', `${Math.abs(i)}`),
            n.style.setProperty('--shift', `${e?.isRTL() ? -1 * o : o}px`),
            i > -1 && i < 1 && (o += 0.5 * a * (1 - Math.abs(i))));
        }
      }
      return {
        init: function (t, n) {
          ((o = n), (e = t).on('ready', S), e.on('initSlides', L), e.on('change', A));
        },
        destroy: function () {
          (h() && e?.emit('thumbs:destroy'),
            e?.off('ready', S),
            e?.off('initSlides', L),
            e?.off('change', A),
            e?.off('render', P),
            e?.off('addSlide', R),
            e?.off('click', O),
            e?.off('refresh', I),
            e?.getGestures()?.off('start', T),
            e?.getContainer()?.classList.remove('has-thumbs'),
            (e = void 0),
            t?.destroy(),
            (t = void 0),
            n?.remove(),
            (n = void 0));
        },
        getCarousel: function () {
          return t;
        },
        getContainer: function () {
          return n;
        },
        getType: function () {
          return d('type');
        },
        isEnabled: f,
      };
    },
    eZ = { iframeAttr: { allow: 'autoplay; fullscreen', scrolling: 'auto' } },
    eG = () => {
      let e;
      function t(e, t) {
        let n = t.src;
        if (!a(n)) return;
        let o = t.type;
        if (!o) {
          if (
            (!o &&
              ('#' === n.charAt(0)
                ? (o = 'inline')
                : n.match(
                      /(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i,
                    )
                  ? (o = 'image')
                  : n.match(/\.(pdf)((\?|#).*)?$/i)
                    ? (o = 'pdf')
                    : n.match(/\.(html|php)((\?|#).*)?$/i) && (o = 'iframe')),
            !o)
          ) {
            let e = n.match(
              /(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i,
            );
            e &&
              ((n = `https://maps.google.${e[1]}/?ll=${(e[2] ? e[2] + '&z=' + Math.floor(parseFloat(e[3])) + (e[4] ? e[4].replace(/^\//, '&') : '') : e[4] + '').replace(/\?/, '&')}&output=${e[4] && e[4].indexOf('layer=c') > 0 ? 'svembed' : 'embed'}`),
              (o = 'gmap'));
          }
          if (!o) {
            let e = n.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);
            e &&
              ((n = `https://maps.google.${e[1]}/maps?q=${e[2].replace('query=', 'q=').replace('api=1', '')}&output=embed`),
              (o = 'gmap'));
          }
          ((t.src = n), (t.type = o));
        }
      }
      function n(t, n) {
        ('iframe' === n.type || 'pdf' === n.type || 'gmap' === n.type) &&
          (function (t) {
            let n;
            if (!e || !t.el || !t.src) return;
            let o = document.createElement('iframe');
            for (let [t, i] of (o.classList.add('f-iframe'),
            Object.entries((l((n = e?.getOptions().Html)) ? { ...eZ, ...n } : eZ).iframeAttr || {})))
              o.setAttribute(t, i);
            ((o.onerror = () => {
              e && 1 === e.getState() && e.showError(t, '{{IFRAME_ERROR}}');
            }),
              (o.src = t.src));
            let i = document.createElement('div');
            if ((i.classList.add('f-html'), i.append(o), t.width)) {
              let e = `${t.width}`;
              (e.match(/^\d+$/) && (e += 'px'), (i.style.maxWidth = `${e}`));
            }
            if (t.height) {
              let e = `${t.height}`;
              (e.match(/^\d+$/) && (e += 'px'), (i.style.maxHeight = `${e}`));
            }
            if (t.aspectRatio) {
              let e = t.el.getBoundingClientRect();
              ((i.style.aspectRatio = `${t.aspectRatio}`),
                (i.style[e.width > e.height ? 'width' : 'height'] = 'auto'),
                (i.style[e.width > e.height ? 'maxWidth' : 'maxHeight'] = 'none'));
            }
            ((t.contentEl = o),
              (t.htmlEl = i),
              t.el.classList.add('has-html'),
              t.el.classList.add('has-iframe'),
              t.el.classList.add(`has-${t.type}`),
              t.el.prepend(i),
              e.emit('contentReady', t));
          })(n);
      }
      function o(t, n) {
        ('iframe' === n.type || 'pdf' === n.type || 'gmap' === n.type) &&
          (e?.hideError(n), n.contentEl?.remove(), (n.contentEl = void 0), n.htmlEl?.remove(), (n.htmlEl = void 0));
      }
      return {
        init: function (i) {
          ((e = i).on('addSlide', t), e.on('attachSlideEl', n), e.on('detachSlideEl', o));
        },
        destroy: function () {
          (e?.off('addSlide', t), e?.off('attachSlideEl', n), e?.off('detachSlideEl', o), (e = void 0));
        },
      };
    },
    eX = (e, t = {}) => {
      let n = new URLSearchParams(new URL(e).search),
        o = new URLSearchParams();
      for (let [e, i] of [...n, ...Object.entries(t)]) {
        let t = i + '';
        if ('t' === e) {
          let e = t.match(/((\d*)m)?(\d*)s?/);
          e && o.set('start', 60 * parseInt(e[2] || '0') + parseInt(e[3] || '0') + '');
        } else o.set(e, t);
      }
      let i = o + '',
        r = e.match(/#t=((.*)?\d+s)/);
      return (r && (i += `#t=${r[1]}`), i);
    },
    eY = {
      autoplay: !1,
      html5videoTpl: `<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">
    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn't support embedded videos.</video>`,
      iframeAttr: { allow: 'autoplay; fullscreen', scrolling: 'auto', credentialless: '' },
      vimeo: { byline: 1, color: '00adef', controls: 1, dnt: 1, muted: 0 },
      youtube: { controls: 1, enablejsapi: 1, nocookie: 1, rel: 0, fs: 1 },
    },
    eU = () => {
      let e,
        t = !1;
      function n() {
        let t = e?.getOptions().Video;
        return l(t) ? { ...eY, ...t } : eY;
      }
      function o() {
        return e?.getPage()?.slides[0];
      }
      let i = (t) => {
        try {
          let n = JSON.parse(t.data);
          if ('https://player.vimeo.com' === t.origin) {
            if ('ready' === n.event)
              for (let n of Array.from(e?.getContainer()?.getElementsByClassName('f-iframe') || []))
                n instanceof HTMLIFrameElement && n.contentWindow === t.source && (n.dataset.ready = 'true');
          } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && 'onReady' === n.event) {
            let e = document.getElementById(n.id);
            e && (e.dataset.ready = 'true');
          }
        } catch (e) {}
      };
      function r(e, t) {
        let o = t.src;
        if (!a(o)) return;
        let i = t.type;
        if (!i || 'html5video' === i) {
          let e = o.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);
          e &&
            ((i = 'html5video'),
            (t.html5videoFormat = t.html5videoFormat || 'video/' + ('ogv' === e[1] ? 'ogg' : e[1])));
        }
        if (!i || 'youtube' === i) {
          let e = o.match(
            /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i,
          );
          if (e) {
            let r = { ...n().youtube, ...(t.youtube || {}) },
              l = `www.youtube${r.nocookie ? '-nocookie' : ''}.com`,
              a = eX(o, r),
              s = encodeURIComponent(e[2]);
            ((t.videoId = s),
              (t.src = `https://${l}/embed/${s}?${a}`),
              (t.thumb = t.thumb || `https://i.ytimg.com/vi/${s}/mqdefault.jpg`),
              (i = 'youtube'));
          }
        }
        if (!i || 'vimeo' === i) {
          let e = o.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);
          if (e) {
            let r = eX(o, { ...n().vimeo, ...(t.vimeo || {}) }),
              l = encodeURIComponent(e[2]),
              a = e[5] || '';
            ((t.videoId = l),
              (t.src = `https://player.vimeo.com/video/${l}?${a ? `h=${a}${r ? '&' : ''}` : ''}${r}`),
              (i = 'vimeo'));
          }
        }
        t.type = i;
      }
      function s(t, o) {
        ('html5video' === o.type &&
          (function (t) {
            if (!e || !t.el || !t.src) return;
            let { el: o, src: i } = t;
            if (!o || !i) return;
            let r = t.html5videoTpl || n().html5videoTpl,
              l = t.html5videoFormat || n().html5videoFormat;
            if (!r) return;
            let s = t.poster || (t.thumb && a(t.thumb) ? t.thumb : ''),
              u = c(
                r
                  .replace(/\{\{src\}\}/gi, i + '')
                  .replace(/\{\{format\}\}/gi, l || '')
                  .replace(/\{\{poster\}\}/gi, s + ''),
              );
            if (!u) return;
            let d = document.createElement('div');
            (d.classList.add('f-html'),
              d.append(u),
              (t.contentEl = u),
              (t.htmlEl = d),
              o.classList.add(`has-${t.type}`),
              o.prepend(d),
              g(t),
              e.emit('contentReady', t));
          })(o),
          ('youtube' === o.type || 'vimeo' === o.type) &&
            (function (t) {
              if (!e || !t.el || !t.src) return;
              let o = document.createElement('iframe');
              for (let [e, i] of (o.classList.add('f-iframe'),
              o.setAttribute('id', `f-iframe_${t.videoId}`),
              Object.entries(n().iframeAttr || {})))
                o.setAttribute(e, i);
              ((o.onload = () => {
                e &&
                  1 === e.getState() &&
                  'youtube' === t.type &&
                  o.contentWindow?.postMessage(JSON.stringify({ event: 'listening', id: o.getAttribute('id') }), '*');
              }),
                (o.onerror = () => {
                  e && 1 === e.getState() && e?.showError(t, '{{IFRAME_ERROR}}');
                }),
                (o.src = t.src));
              let i = document.createElement('div');
              (i.classList.add('f-html'),
                i.append(o),
                (t.contentEl = o),
                (t.htmlEl = i),
                t.el.classList.add('has-html'),
                t.el.classList.add('has-iframe'),
                t.el.classList.add(`has-${t.type}`),
                t.el.prepend(i),
                g(t),
                e.emit('contentReady', t));
            })(o));
      }
      function u(e, t) {
        (('html5video' === t.type || 'youtube' === t.type || 'vimeo' === t.type) &&
          (t.contentEl?.remove(), (t.contentEl = void 0), t.htmlEl?.remove(), (t.htmlEl = void 0)),
          t.poller && clearTimeout(t.poller));
      }
      function d() {
        t = !1;
      }
      function f() {
        if (t) return;
        t = !0;
        let e = o();
        (e && void 0 !== e.autoplay ? e.autoplay : n().autoplay) &&
          (!(function () {
            let e = o(),
              t = e?.el;
            if (t && e?.type === 'html5video')
              try {
                let e = t.querySelector('video');
                if (e) {
                  let t = e.play();
                  void 0 !== t &&
                    t
                      .then(() => {})
                      .catch((t) => {
                        ((e.muted = !0), e.play());
                      });
                }
              } catch (e) {}
            let n = e?.htmlEl;
            n instanceof HTMLIFrameElement &&
              n.contentWindow?.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
          })(),
          (function () {
            let e = o(),
              t = e?.type;
            if (!(e?.el && ('youtube' === t || 'vimeo' === t))) return;
            let n = () => {
              if (e.contentEl && e.contentEl instanceof HTMLIFrameElement && e.contentEl.contentWindow) {
                let t;
                if ('true' === e.contentEl.dataset.ready) {
                  ((t =
                    'youtube' === e.type
                      ? { event: 'command', func: 'playVideo' }
                      : { method: 'play', value: 'true' }) &&
                    e.contentEl.contentWindow.postMessage(JSON.stringify(t), '*'),
                    (e.poller = void 0));
                  return;
                }
                'youtube' === e.type &&
                  ((t = { event: 'listening', id: e.contentEl.getAttribute('id') }),
                  e.contentEl.contentWindow.postMessage(JSON.stringify(t), '*'));
              }
              e.poller = setTimeout(n, 250);
            };
            n();
          })());
      }
      function g(e) {
        let t = e?.htmlEl;
        if (e && t && ('html5video' === e.type || 'youtube' === e.type || 'vimeo' === e.type)) {
          if (
            ((t.style.aspectRatio = ''),
            (t.style.width = ''),
            (t.style.height = ''),
            (t.style.maxWidth = ''),
            (t.style.maxHeight = ''),
            e.width)
          ) {
            let n = `${e.width}`;
            (n.match(/^\d+$/) && (n += 'px'), (t.style.maxWidth = `${n}`));
          }
          if (e.height) {
            let n = `${e.height}`;
            (n.match(/^\d+$/) && (n += 'px'), (t.style.maxHeight = `${n}`));
          }
          if (e.aspectRatio) {
            let n = e.aspectRatio.split('/'),
              o = parseFloat(n[0].trim()),
              i = n[1] ? parseFloat(n[1].trim()) : 0;
            t.offsetHeight;
            let r = t.getBoundingClientRect(),
              l = (o && i ? o / i : o) < (r.width || 1) / (r.height || 1);
            ((t.style.aspectRatio = `${e.aspectRatio}`),
              (t.style.width = l ? 'auto' : ''),
              (t.style.height = l ? '' : 'auto'));
          }
        }
      }
      function m() {
        g(o());
      }
      return {
        init: function (t) {
          ((e = t).on('addSlide', r),
            e.on('attachSlideEl', s),
            e.on('detachSlideEl', u),
            e.on('ready', f),
            e.on('change', d),
            e.on('settle', f),
            e.on('refresh', m),
            window.addEventListener('message', i));
        },
        destroy: function () {
          (e?.off('addSlide', r),
            e?.off('attachSlideEl', s),
            e?.off('detachSlideEl', u),
            e?.off('ready', f),
            e?.off('change', d),
            e?.off('settle', f),
            e?.off('refresh', m),
            window.removeEventListener('message', i),
            (e = void 0));
        },
      };
    },
    eK = {
      autoStart: !1,
      btnTpl:
        '<button data-fullscreen-action="toggle" class="f-button" title="{{TOGGLE_FULLSCREEN}}"><svg><g><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>',
    },
    eJ = 'in-fullscreen-mode',
    eQ = () => {
      let e;
      function t(t) {
        let n = e?.getOptions().Fullscreen,
          o = (l(n) ? { ...eK, ...n } : eK)[t];
        return o && 'function' == typeof o && e ? o(e) : o;
      }
      function n() {
        e?.getPlugins().Toolbar?.add('fullscreen', { tpl: t('btnTpl') });
      }
      function o() {
        if (t('autoStart')) {
          let e = r();
          e && s(e);
        }
      }
      function i(e, t) {
        let n = t.target;
        n && !t.defaultPrevented && 'toggle' === n.dataset.fullscreenAction && u();
      }
      function r() {
        return t('el') || e?.getContainer() || void 0;
      }
      function a() {
        let e = document;
        return e.fullscreenEnabled ? !!e.fullscreenElement : !!e.webkitFullscreenEnabled && !!e.webkitFullscreenElement;
      }
      function s(e) {
        let t,
          n = document;
        return (
          e || (e = n.documentElement),
          n.fullscreenEnabled
            ? (t = e.requestFullscreen())
            : n.webkitFullscreenEnabled && (t = e.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)),
          t &&
            t.then(() => {
              e.classList.add(eJ);
            }),
          t
        );
      }
      function c() {
        let e,
          t = document;
        return (
          t.fullscreenEnabled
            ? (e = t.fullscreenElement && t.exitFullscreen())
            : t.webkitFullscreenEnabled && (e = t.webkitFullscreenElement && t.webkitExitFullscreen()),
          e &&
            e.then(() => {
              r()?.classList.remove(eJ);
            }),
          e
        );
      }
      function u() {
        if (a()) c();
        else {
          let e = r();
          e && s(e);
        }
      }
      return {
        init: function (t) {
          ((e = t).on('initPlugins', n), e.on('ready', o), e.on('click', i));
        },
        destroy: function () {
          (e?.off('initPlugins', n), e?.off('ready', o), e?.off('click', i));
        },
        exit: c,
        inFullscreen: a,
        request: s,
        toggle: u,
      };
    },
    e0 = !1,
    e1 = !1,
    e2 = !1,
    e5 = !1,
    e4 = () => {
      let e = new URL(document.URL).hash,
        t = e.slice(1).split('-'),
        n = t[t.length - 1],
        o = (n && /^\+?\d+$/.test(n) && parseInt(t.pop() || '1', 10)) || 1;
      return { urlHash: e, urlSlug: t.join('-'), urlIndex: o };
    },
    e3 = () => {
      let e = i?.getInstance();
      return !!e && 1 == e.getState();
    },
    e6 = () => {
      if (!i || e3()) return;
      let { urlSlug: e, urlIndex: t } = e4();
      if (!e) return;
      let n = document.querySelector(`[data-slug="${e}"]`);
      (n && i.fromTriggerEl(n),
        !e3() &&
          (n = document.querySelectorAll(`[data-fancybox="${e}"]`)[t - 1]) &&
          i.fromTriggerEl(n, { startIndex: t - 1 }),
        e3() &&
          n &&
          !n.closest('[inert]') &&
          n.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' }));
    },
    e7 = () => {
      if (!i || e2) return;
      let e = i?.getInstance(),
        t = e?.getCarousel();
      if (e?.getOptions().Hash === !1) return;
      let { urlSlug: n, urlIndex: o } = e4();
      if (e && t) {
        for (let e of t.getSlides() || [])
          if (n === e.slug || (n === e.fancybox && e.index === o - 1)) {
            ((e1 = !1), t.goTo(e.index));
            return;
          }
        ((e5 = !0), e.close(), (e5 = !1));
      }
      e6();
    },
    e9 = () => {
      i &&
        ((r = setTimeout(() => {
          ((e0 = !0), e6(), (e0 = !1));
        }, 300)),
        window.addEventListener('hashchange', e7, !1));
    },
    e8 = () => {
      let e,
        t = 'auto',
        n = '';
      function o() {
        if (!e || !e.isTopMost() || !1 === e.getOptions().Hash) return;
        if (e0) {
          let t = e.getOptions().sync;
          t && t.goTo(e?.getCarousel()?.getPageIndex() || 0, { transition: !1, tween: !1 });
        }
        let o = e.getCarousel();
        if (!o) return;
        let { urlHash: r, urlSlug: l } = e4(),
          a = e.getSlide();
        if (!a) return;
        let s = a.slug || a.fancybox || '',
          c = parseInt(a.index + '', 10) + 1;
        if (!s) return;
        let u = a.slug ? `#${a.slug}` : `#${s}-${c}`;
        (2 > (e.getCarousel()?.getPages()?.length || 0) && (u = `#${s}`),
          r !== u && (n = r),
          history.scrollRestoration && ((t = history.scrollRestoration), (history.scrollRestoration = 'manual')),
          o.on('change', i));
        let d = s !== l;
        try {
          (window.history[d ? 'pushState' : 'replaceState'](
            {},
            document.title,
            window.location.pathname + window.location.search + u,
          ),
            d && (e1 = !0));
        } catch (e) {}
      }
      function i() {
        if (!e || !e.isTopMost() || !1 === e.getOptions().Hash) return;
        let t = e.getSlide();
        if (!t) return;
        let n = t.slug || t.fancybox || '',
          o = t.index + 1,
          i = t.slug ? `#${t.slug}` : `#${n}-${o}`;
        e2 = !0;
        try {
          window.history.replaceState({}, document.title, window.location.pathname + window.location.search + i);
        } catch (e) {}
        e2 = !1;
      }
      function l() {
        if (e5 || !e || !e.isTopMost() || !1 === e.getOptions().Hash) return;
        let t = e.getSlide();
        if (t && t.fancybox) {
          e2 = !0;
          try {
            e1 &&
            !(function () {
              if (window.parent === window) return !1;
              try {
                var e = window.frameElement;
              } catch (t) {
                e = null;
              }
              return null === e ? 'data:' === location.protocol : e.hasAttribute('sandbox');
            })()
              ? window.history.back()
              : window.history.replaceState({}, document.title, window.location.pathname + window.location.search + n);
          } catch (e) {}
          e2 = !1;
        }
      }
      return {
        init: function (t) {
          (clearTimeout(r), (e = t).on('ready', o), e.on('close', l));
        },
        destroy: function () {
          (e?.off('ready', o), e?.off('close', l));
          let n = e?.getCarousel();
          (n && n.off('change', i), (e = void 0), history.scrollRestoration && t && (history.scrollRestoration = t));
        },
      };
    };
  ((e8.startFromUrl = e6),
    (e8.setup = function (e) {
      !i &&
        ((i = e),
        m() &&
          (/complete|interactive|loaded/.test(document.readyState)
            ? e9()
            : document.addEventListener('DOMContentLoaded', e9)));
    }));
  let te = {
      ...em,
      CLOSE: 'Close',
      NEXT: 'Next',
      PREV: 'Previous',
      MODAL: 'You can close this modal content with the ESC key',
      ELEMENT_NOT_FOUND: 'HTML Element Not Found',
      IFRAME_ERROR: 'Error Loading Page',
    },
    tt =
      '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24"><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>';
  ej().add('close', { tpl: tt });
  let tn = (e) => {
      e.cancelable && e.preventDefault();
    },
    to = (e = null, t = '', n) => {
      if (!e || !e.parentElement || !t) {
        n && n();
        return;
      }
      ti(e);
      let o = (i) => {
        i.target === e &&
          e.dataset.animationName &&
          (e.removeEventListener('animationend', o), delete e.dataset.animationName, n && n(), e.classList.remove(t));
      };
      ((e.dataset.animationName = t), e.addEventListener('animationend', o), y(e, t));
    },
    ti = (e) => {
      e && e.dispatchEvent(new CustomEvent('animationend', { bubbles: !1, cancelable: !0, currentTarget: e }));
    },
    tr =
      (((k = {})[(k.Init = 0)] = 'Init'),
      (k[(k.Ready = 1)] = 'Ready'),
      (k[(k.Closing = 2)] = 'Closing'),
      (k[(k.Destroyed = 3)] = 'Destroyed'),
      k),
    tl = {
      ajax: null,
      backdropClick: 'close',
      Carousel: {},
      closeButton: 'auto',
      closeExisting: !1,
      delegateEl: void 0,
      dragToClose: !0,
      fadeEffect: !0,
      groupAll: !1,
      groupAttr: 'data-fancybox',
      hideClass: 'f-fadeOut',
      hideScrollbar: !0,
      id: void 0,
      idle: !1,
      keyboard: {
        Escape: 'close',
        Delete: 'close',
        Backspace: 'close',
        PageUp: 'next',
        PageDown: 'prev',
        ArrowUp: 'prev',
        ArrowDown: 'next',
        ArrowRight: 'next',
        ArrowLeft: 'prev',
      },
      l10n: te,
      mainClass: '',
      mainStyle: {},
      mainTpl: `<dialog class="fancybox__dialog">
    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">
      <div class="fancybox__backdrop"></div>
      <div class="fancybox__carousel"></div>
    </div>
  </dialog>`,
      modal: !0,
      on: {},
      parentEl: void 0,
      placeFocusBack: !0,
      showClass: 'f-zoomInUp',
      startIndex: 0,
      sync: void 0,
      theme: 'dark',
      triggerEl: void 0,
      triggerEvent: void 0,
      zoomEffect: !0,
    },
    ta = new Map(),
    ts = 0,
    tc = 'with-fancybox';
  function tu(e, t = {}) {
    let n, o, i, r;
    if (!(e && e instanceof Element)) return;
    let l = {};
    for (let [t, a] of td.openers)
      if (t.contains(e))
        for (let [s, c] of a) {
          let a;
          if (s) {
            for (let n of t.querySelectorAll(s))
              if (n.contains(e)) {
                a = n;
                break;
              }
            if (!a) continue;
          }
          for (let [s, u] of c) {
            let c = null;
            try {
              c = e.closest(s);
            } catch (e) {}
            c && ((o = t), (i = a), (n = c), (r = s), g(l, u || {}));
          }
        }
    if (!o || !r || !n) return;
    let a = g({}, tl, t, l, { triggerEl: n }),
      s = [].slice.call((i || o).querySelectorAll(r)),
      c = n.closest('.f-carousel'),
      u = c?.carousel;
    if (u && !(i && c.contains(i))) {
      let e = [];
      for (let t of u?.getSlides()) {
        let n = t.el;
        n && (n.matches(r) ? e.push(n) : e.push(...[].slice.call(n.querySelectorAll(r))));
      }
      e.length && ((s = [...e]), u.getPlugins().Autoplay?.pause(), u.getPlugins().Autoscroll?.pause(), (a.sync = u));
    }
    if (!1 === a.groupAll) {
      let e = a.groupAttr,
        t = e && n ? n.getAttribute(`${e}`) : '';
      s = e && t ? s.filter((n) => n.getAttribute(`${e}`) === t) : [n];
    }
    if (!s.length) return;
    a.triggerEvent?.preventDefault();
    let d = td.getInstance();
    if (d) {
      let e = d.getOptions().triggerEl;
      if (e && s.indexOf(e) > -1) return;
    }
    return (
      { ...(a.Carousel || {}) }.rtl && (s = s.reverse()),
      n && void 0 === t.startIndex && (a.startIndex = s.indexOf(n)),
      td.fromNodes(s, a)
    );
  }
  let td = {
    Plugins: { Hash: e8 },
    version: '6.1.6',
    openers: new Map(),
    bind: function (e, t, n, o) {
      if (!m()) return;
      let i = document.body,
        r = null,
        l = '[data-fancybox]',
        s = {};
      (e instanceof Element && (i = e),
        a(e) && a(t) ? ((r = e), (l = t)) : a(t) && a(n) ? ((r = t), (l = n)) : a(t) ? (l = t) : a(e) && (l = e),
        'object' == typeof t && (s = t || {}),
        'object' == typeof n && (s = n || {}),
        'object' == typeof o && (s = o || {}),
        (function (e, t, n, o = {}) {
          if (!(e && e instanceof Element) || !n) return;
          let i = td.openers.get(e) || new Map(),
            r = i.get(t) || new Map();
          if (
            (r.set(n, o),
            i.set(t, r),
            td.openers.set(e, i),
            1 === i.size && e.addEventListener('click', td.fromEvent),
            1 === td.openers.size)
          )
            for (let e of Object.values(td.Plugins)) {
              let t = e.setup;
              'function' == typeof t && t(td);
            }
        })(i, r, l, s));
    },
    close: function (e = !0, ...t) {
      if (e) for (let e of ta.values()) e.close(...t);
      else {
        let e = td.getInstance();
        e && e.close(...t);
      }
    },
    destroy: function () {
      let e;
      for (; (e = td.getInstance()); ) e.destroy();
      for (let e of td.openers.keys()) e.removeEventListener('click', td.fromEvent);
      td.openers.clear();
    },
    fromEvent: function (e) {
      if (e.defaultPrevented || (e.button && 0 !== e.button) || e.ctrlKey || e.metaKey || e.shiftKey) return;
      let t = e.composedPath()[0],
        n = { triggerEvent: e };
      if (t.closest('.fancybox__container.is-hiding')) {
        (tn(e), e.stopPropagation());
        return;
      }
      let o = t.closest('[data-fancybox-delegate]') || void 0;
      if (o) {
        let e = o.dataset.fancyboxDelegate || '',
          i = document.querySelectorAll(`[data-fancybox="${e}"]`),
          r = parseInt(o.dataset.fancyboxIndex || '', 10) || 0;
        ((t = i[r] || i[0]), g(n, { delegateEl: o, startIndex: r }));
      }
      return tu(t, n);
    },
    fromNodes: function (e, t) {
      t = g({}, tl, t || {});
      let n = [],
        o = (e) =>
          e instanceof HTMLImageElement
            ? e
            : e instanceof HTMLElement
              ? e.querySelector('img:not([aria-hidden])')
              : void 0;
      for (let i of e) {
        let r = i.dataset || {},
          l = t.delegateEl && e.indexOf(i) === t.startIndex ? t.delegateEl : void 0,
          a = o(l) || o(i) || void 0,
          s = r.src || i.getAttribute('href') || i.getAttribute('currentSrc') || i.getAttribute('src') || void 0,
          c =
            r.thumb ||
            r.thumbSrc ||
            a?.getAttribute('currentSrc') ||
            a?.getAttribute('src') ||
            a?.dataset.lazySrc ||
            void 0,
          u = {
            src: s,
            alt: r.alt || a?.getAttribute('alt') || void 0,
            thumbSrc: c,
            thumbEl: a,
            triggerEl: i,
            delegateEl: l,
          };
        for (let e in r) {
          let t = r[e] + '';
          ((t = 'false' !== t && ('true' === t || t)), (u[e] = t));
        }
        n.push(u);
      }
      return td.show(n, t);
    },
    fromSelector: function (e, t, n, o) {
      if (!m()) return;
      let i = document.body,
        r = null,
        l = '[data-fancybox]',
        s = {};
      for (let [c, u] of (e instanceof Element && (i = e),
      a(e) && a(t) ? ((r = e), (l = t)) : a(t) && a(n) ? ((r = t), (l = n)) : a(t) ? (l = t) : a(e) && (l = e),
      'object' == typeof t && (s = t || {}),
      'object' == typeof n && (s = n || {}),
      'object' == typeof o && (s = o || {}),
      td.openers))
        for (let [e, t] of u)
          for (let [n, o] of t)
            if (c === i && e === r) {
              let t = i.querySelector((e ? `${e} ` : '') + l);
              if (t && t.matches(n)) return td.fromTriggerEl(t, s);
            }
    },
    fromTriggerEl: tu,
    getCarousel: function () {
      return td.getInstance()?.getCarousel() || void 0;
    },
    getDefaults: function () {
      return tl;
    },
    getInstance: function (e) {
      if (e) {
        let t = ta.get(e);
        return t && t.getState() !== tr.Destroyed ? t : void 0;
      }
      return (
        Array.from(ta.values())
          .reverse()
          .find((e) => {
            if (e.getState() !== tr.Destroyed) return e;
          }) || void 0
      );
    },
    getSlide: function () {
      return td.getInstance()?.getSlide() || void 0;
    },
    show: function (e = [], t = {}) {
      return (() => {
        let e,
          t,
          n,
          o,
          i,
          r,
          u,
          m = tr.Init,
          p = { ...tl },
          E = -1,
          w = {},
          x = [],
          M = !1,
          L = !0,
          S = 0;
        function T(e, ...t) {
          let n = p[e];
          return n && 'function' == typeof n ? n(ed, ...t) : n;
        }
        function P(e, t = []) {
          let n = T('l10n') || {};
          e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t) => n[t] || e);
          for (let n = 0; n < t.length; n++) e = e.split(t[n][0]).join(t[n][1]);
          return e.replace(/\{\{(.*?)\}\}/g, (e, t) => t);
        }
        let A = new Map();
        function R(e, ...t) {
          let n = [...(A.get(e) || [])];
          for (let [t, o] of Object.entries(p.on || {})) (t === e || t.split(' ').indexOf(e) > -1) && n.push(o);
          for (let e of n) e && 'function' == typeof e && e(ed, ...t);
          '*' !== e && R('*', e, ...t);
        }
        function C() {
          v(r, 'is-revealing');
          try {
            document.activeElement === i && (r?.querySelector('[autofocus]') || r).focus();
          } catch (e) {}
        }
        function O(t, n) {
          (Z(n),
            D(),
            n.el?.addEventListener('click', z),
            ('inline' === n.type || 'clone' === n.type) &&
              (function (t) {
                if (!e || !t || !t.el) return;
                let n = null;
                if (a(t.src)) {
                  let e = t.src.split('#', 2).pop();
                  n = e ? document.getElementById(e) : null;
                }
                if (n) {
                  if ((y(n, 'f-html'), 'clone' === t.type || n.closest('.fancybox__carousel'))) {
                    let e = (n = n.cloneNode(!0)).dataset.animationName;
                    e && (n.classList.remove(e), delete n.dataset.animationName);
                    let o = n.getAttribute('id');
                    ((o = o ? `${o}--clone` : `clone-${E}-${t.index}`), n.setAttribute('id', o));
                  } else if (n.parentNode) {
                    let e = document.createElement('div');
                    ((e.inert = !0), n.parentNode.insertBefore(e, n), (t.placeholderEl = e));
                  }
                  ((t.htmlEl = n),
                    y(t.el, 'has-html'),
                    t.el.prepend(n),
                    n.classList.remove('hidden'),
                    'none' === n.style.display && (n.style.display = ''),
                    'none' === getComputedStyle(n).getPropertyValue('display') &&
                      (n.style.display = n.dataset.display || 'flex'),
                    e?.emit('contentReady', t));
                } else e?.showError(t, '{{ELEMENT_NOT_FOUND}}');
              })(n),
            'ajax' === n.type &&
              (function (t) {
                let n = t.el;
                if (!n || t.htmlEl || t.xhr) return;
                (e?.showLoading(t), (t.state = ey.Loading));
                let o = new XMLHttpRequest();
                o.onreadystatechange = function () {
                  if (o.readyState === XMLHttpRequest.DONE && m === tr.Ready)
                    if ((e?.hideLoading(t), (t.state = ey.Loaded), 200 === o.status)) {
                      let i = o.responseText + '',
                        r = null,
                        l = null;
                      if (t.filter) {
                        let e = document.createElement('div');
                        ((e.innerHTML = i), (l = e.querySelector(t.filter + '')));
                      }
                      (l && l instanceof HTMLElement ? (r = l) : ((r = document.createElement('div')).innerHTML = i),
                        r.classList.add('f-html'),
                        (t.htmlEl = r),
                        n.classList.add('has-html'),
                        n.classList.add('has-ajax'),
                        n.prepend(r),
                        e?.emit('contentReady', t));
                    } else e?.showError(t);
                };
                let i = T('ajax') || null;
                (o.open(i ? 'POST' : 'GET', t.src + ''),
                  o.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded'),
                  o.setRequestHeader('X-Requested-With', 'XMLHttpRequest'),
                  o.send(i),
                  (t.xhr = o));
              })(n));
        }
        function I(e, t) {
          var n;
          let o, i;
          (G(t),
            t.el?.removeEventListener('click', z),
            ('inline' === t.type || 'clone' === t.type) &&
              ((o = (n = t).htmlEl),
              (i = n.placeholderEl),
              o &&
                ('none' !== getComputedStyle(o).getPropertyValue('display') && (o.style.display = 'none'),
                o.offsetHeight),
              i && (o && i.parentNode && i.parentNode.insertBefore(o, i), i.remove()),
              (n.htmlEl = void 0),
              (n.placeholderEl = void 0)),
            t.xhr && (t.xhr.abort(), (t.xhr = void 0)));
        }
        function z(e) {
          if (!Y()) return;
          if (m !== tr.Ready) {
            (tn(e), e.stopPropagation());
            return;
          }
          if (e.defaultPrevented || !Q.isClickAllowed()) return;
          let t = e.composedPath()[0];
          t.closest('.fancybox__carousel') && t.classList.contains('fancybox__slide') && q(e);
        }
        function k() {
          ((L = !1), r && e && r.classList.remove('is-revealing'), D());
          let t = T('sync');
          if (e && t) {
            let n = t.getPageIndex(e.getPageIndex()) || 0;
            t.goTo(n, { transition: !1, tween: !1 });
          }
        }
        function _() {
          ((function () {
            let o = e?.getViewport();
            if (!T('dragToClose') || !e || !o || !(t = Q(o).init())) return;
            let i = !1,
              l = 0,
              a = 0,
              s = {},
              c = 1;
            function u() {
              n?.spring({
                clamp: !0,
                mass: 1,
                tension: 0 === a ? 140 : 960,
                friction: 17,
                restDelta: 0.1,
                restSpeed: 0.1,
                maxSpeed: 1 / 0,
              })
                .from({ y: l })
                .to({ y: a })
                .start();
              let t = e?.getViewport()?.getBoundingClientRect().height || 0,
                o = U()?.panzoomRef;
              if (t && o)
                if (0 === a) o.execute(ei.Reset);
                else {
                  let e = h(Math.abs(l), 0, 0.33 * t, c, 0.77 * c, !1);
                  o.execute(ei.ZoomTo, { scale: e });
                }
            }
            let f = (t) => {
              let n = t.srcEvent,
                o = n.target;
              return e && !(j(n) && n.touches?.length > 1) && o && !d(o);
            };
            ((n = V().on('step', (e) => {
              if (r && o && m === tr.Ready) {
                let t = o.getBoundingClientRect().height,
                  n = h(Math.abs((l = Math.min(t, Math.max(-1 * t, e.y)))), 0, 0.5 * t, 1, 0, !0);
                (r.style.setProperty('--f-drag-opacity', n + ''), r.style.setProperty('--f-drag-offset', l + 'px'));
              }
            })),
              t
                .on('start', function () {
                  i || (n?.pause(), (a = l));
                })
                .on('panstart', (t) => {
                  if (!i && f(t) && 'y' === t.axis) {
                    (tn(t.srcEvent), (i = !0), ea(), e?.getViewport()?.classList.add('is-dragging'));
                    let n = U()?.panzoomRef;
                    if (n) {
                      c = n.getTransform().scale || 1;
                      let e = n.getOptions();
                      ((s = { ...e }), (e.bounds = !1), (e.gestures = !1));
                    }
                  } else i = !1;
                })
                .on('pan', function (e) {
                  i && f(e) && (tn(e.srcEvent), e.srcEvent.stopPropagation(), 'y' === e.axis && ((a += e.deltaY), u()));
                })
                .on('end', (t) => {
                  if ((e?.getViewport()?.classList.remove('is-dragging'), i)) {
                    let e = U()?.panzoomRef;
                    if (e) {
                      e.getTween()?.end();
                      let t = e.getOptions();
                      ((t.bounds = s.bounds || !1), (t.gestures = s.gestures || !1));
                    }
                    f(t) &&
                      'y' === t.axis &&
                      (Math.abs(t.velocityY) > 5 || Math.abs(l) > 50) &&
                      es(t.srcEvent, 'f-throwOut' + (t.velocityY > 0 ? 'Down' : 'Up'));
                  }
                  ((i = !1), m === tr.Ready && 0 !== l && ((a = 0), u()));
                }));
          })(),
            document.body.addEventListener('click', W),
            document.body.addEventListener('keydown', B, { passive: !1, capture: !0 }),
            D(),
            et());
          let o = T('sync');
          (e && o && o.getTween()?.start(), X(U()));
        }
        function $() {
          e?.canGoNext() ? et() : er();
        }
        function F(e, t) {
          (Z(t), X(t));
        }
        function H() {
          let t = e?.getPlugins().Thumbs;
          (b(r, 'has-thumbs', t?.isEnabled() || !1),
            b(r, 'has-vertical-thumbs', !!t && ('scrollable' === t.getType() || t.getCarousel()?.isVertical() === !0)));
        }
        function D() {
          if (r) {
            let t = e?.getPages() || [],
              n = e?.getPageIndex() || 0;
            for (let e of r.querySelectorAll('[data-fancybox-index]')) e.innerHTML = n + '';
            for (let e of r.querySelectorAll('[data-fancybox-page]')) e.innerHTML = n + 1 + '';
            for (let e of r.querySelectorAll('[data-fancybox-pages]')) e.innerHTML = t.length + '';
          }
        }
        function q(e) {
          e.composedPath()[0].closest('[data-fancybox-close]')
            ? es(e)
            : (R('backdropClick', e), e.defaultPrevented || (T('backdropClick') && es(e)));
        }
        function N() {
          eo();
        }
        function B(t) {
          let n;
          if (!Y() || m !== tr.Ready) return;
          let o = t.key,
            i = T('keyboard');
          if (!i || t.ctrlKey || t.altKey || t.shiftKey) return;
          let r = t.composedPath()[0];
          if (
            !s(r) ||
            ('Escape' !== o &&
              ((n = 'input,textarea,select,option,video,iframe,[contenteditable],[data-selectable],[data-draggable]'),
              r.matches(n) || r.closest(n))) ||
            (R('keydown', t), t.defaultPrevented)
          )
            return;
          let l = i[o];
          if (l)
            switch (l) {
              case 'close':
                es(t);
                break;
              case 'next':
                (tn(t), e?.next());
                break;
              case 'prev':
                (tn(t), e?.prev());
            }
        }
        function W(e) {
          if (!Y() || m !== tr.Ready || (eo(), e.defaultPrevented)) return;
          let t = e.composedPath()[0],
            n = !!t.closest('[data-fancybox-close]'),
            o = t.classList.contains('fancybox__backdrop');
          (n || o) && q(e);
        }
        function Z(t) {
          let { el: n, htmlEl: o, panzoomRef: i, closeButtonEl: r } = t,
            l = i ? i.getWrapper() : o;
          if (!n || !n.parentElement || !l) return;
          let a = T('closeButton');
          if (('auto' === a && (a = e?.getPlugins().Toolbar?.isEnabled() !== !0), !a)) return void G(t);
          if (!r) {
            let e = c(P(tt));
            e &&
              (y(e, 'is-close-button'),
              (t.closeButtonEl = l.insertAdjacentElement('afterbegin', e)),
              y(n, 'has-close-btn'));
          }
        }
        function G(e) {
          (e.closeButtonEl && (e.closeButtonEl.remove(), (e.closeButtonEl = void 0)), v(e.el, 'has-close-btn'));
        }
        function X(t) {
          if (
            !(
              L &&
              e &&
              e.getState() === eh.Ready &&
              t &&
              t.index === e.getOptions().initialPage &&
              t.el &&
              t.el.parentElement
            ) ||
            (void 0 !== t.state && t.state !== ey.Loaded)
          )
            return;
          L = !1;
          let n = t.panzoomRef,
            o = n?.getTween(),
            i = T('zoomEffect') && o ? J(t) : void 0;
          if (n && o && i) {
            let { x: e, y: t, scale: r } = n.getStartPosition();
            o.spring({ tension: 215, friction: 25, restDelta: 0.001, restSpeed: 0.001, maxSpeed: 1 / 0 })
              .from(i)
              .to({ x: e, y: t, scale: r })
              .start();
            return;
          }
          let r = n?.getContent() || t.htmlEl;
          r && to(r, T('showClass', t));
        }
        function Y() {
          return td.getInstance()?.getId() === E;
        }
        function U() {
          return e?.getPage()?.slides[0];
        }
        function K() {
          let e = U();
          return e ? e.triggerEl || T('triggerEl') : void 0;
        }
        function J(e) {
          let t = e.thumbEl;
          if (
            !t ||
            !((e) => {
              let t = e.getBoundingClientRect(),
                n = e.closest('[style]'),
                o = n?.parentElement;
              if (n && n.style.transform && o) {
                let e = o.getBoundingClientRect();
                if (
                  t.left < e.left ||
                  t.left > e.left + e.width - t.width ||
                  t.top < e.top ||
                  t.top > e.top + e.height - t.height
                )
                  return !1;
              }
              let i = Math.max(document.documentElement.clientHeight, window.innerHeight),
                r = Math.max(document.documentElement.clientWidth, window.innerWidth);
              return !(t.bottom < 0) && !(t.top - i >= 0) && !(t.right < 0) && !(t.left - r >= 0);
            })(t)
          )
            return;
          let n = e.panzoomRef?.getWrapper()?.getBoundingClientRect(),
            o = n?.width,
            i = n?.height;
          if (!o || !i) return;
          let r = t.getBoundingClientRect(),
            l = r.width,
            a = r.height,
            s = r.left,
            c = r.top;
          if (!r || !l || !a) return;
          if (t instanceof HTMLImageElement) {
            let e = window.getComputedStyle(t).getPropertyValue('object-fit');
            if ('contain' === e || 'scale-down' === e) {
              let { width: n, height: o } = ((e, t, n, o, i = 'contain') => {
                if ('contain' === i || e > n || t > o) {
                  let i = Math.min(n / e, o / t);
                  ((e *= i), (t *= i));
                }
                return { width: e, height: t };
              })(t.naturalWidth, t.naturalHeight, l, a, e);
              ((s += (l - n) * 0.5), (c += (a - o) * 0.5), (l = n), (a = o));
            }
          }
          if (Math.abs(o / i - l / a) > 0.1) return;
          let u = s + 0.5 * l - (n.left + 0.5 * o);
          return { x: u, y: c + 0.5 * a - (n.top + 0.5 * i), scale: l / o };
        }
        function ee() {
          (o && clearTimeout(o), (o = void 0), document.removeEventListener('mousemove', N));
        }
        function et() {
          if (M || o) return;
          let e = T('idle');
          e && (o = setTimeout(en, e));
        }
        function en() {
          r && (ee(), y(r, 'is-idle'), document.addEventListener('mousemove', N), (M = !0));
        }
        function eo() {
          M && (er(), et());
        }
        function er() {
          (ee(), r?.classList.remove('is-idle'), (M = !1));
        }
        function ea() {
          var e;
          let t = K();
          !t ||
            ((e = t.getBoundingClientRect()).bottom > 0 &&
              e.right > 0 &&
              e.left < (window.innerWidth || document.documentElement.clientWidth) &&
              e.top < (window.innerHeight || document.documentElement.clientHeight)) ||
            t.closest('[inert]') ||
            t.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' });
        }
        function es(o, i) {
          if (m === tr.Closing || m === tr.Destroyed) return;
          let r = new Event('shouldClose', { bubbles: !0, cancelable: !0 });
          if ((R('shouldClose', r, o), r.defaultPrevented)) return;
          if ((ee(), o)) {
            if (o.defaultPrevented) return;
            (tn(o), o.stopPropagation(), o.stopImmediatePropagation());
          }
          if (((m = tr.Closing), n?.pause(), t?.destroy(), e))
            for (let t of (e.getGestures()?.destroy(), e.getTween()?.pause(), e.getSlides())) {
              let e = t.panzoomRef;
              e &&
                (g(e.getOptions(), {
                  clickAction: !1,
                  dblClickAction: !1,
                  wheelAction: !1,
                  bounds: !1,
                  minScale: 0,
                  maxScale: 1 / 0,
                }),
                e.getGestures()?.destroy(),
                e.getTween()?.pause());
            }
          let l = e?.getPlugins();
          l?.Autoplay?.stop();
          let a = l?.Fullscreen;
          a && a.inFullscreen()
            ? Promise.resolve(a.exit()).then(() => {
                setTimeout(() => {
                  ec(o, i);
                }, 150);
              })
            : ec(o, i);
        }
        function ec(t, n) {
          if (m !== tr.Closing) return;
          (R('close', t),
            (L = !1),
            document.body.removeEventListener('click', W),
            document.body.removeEventListener('keydown', B, { passive: !1, capture: !0 }),
            T('placeFocusBack') && ea());
          let o = document.activeElement;
          (o && i?.contains(o) && o.blur(),
            T('fadeEffect') && (r?.classList.remove('is-ready'), r?.classList.add('is-hiding')),
            r?.classList.add('is-closing'));
          let l = U(),
            a = l?.el,
            s = l?.panzoomRef,
            c = l?.panzoomRef?.getTween(),
            u = n || T('hideClass'),
            d = !1,
            f = !1;
          if (e && l && a && s && c) {
            let e;
            if ((T('zoomEffect') && l.state === ey.Loaded && (e = J(l)), e)) {
              d = !0;
              let t = () => {
                (e = J(l)) ? c.to({ ...el, ...e }) : eu();
              };
              (s.on('refresh', () => {
                t();
              }),
                c
                  .easing(V.Easings.EaseOut)
                  .duration(350)
                  .from({ ...s.getTransform() })
                  .to({ ...el, ...e })
                  .start(),
                a?.getAnimations() &&
                  ((a.style.animationPlayState = 'paused'),
                  requestAnimationFrame(() => {
                    t();
                  })));
            }
          }
          let g = l?.htmlEl || l?.panzoomRef?.getWrapper();
          (g && ti(g),
            !d &&
              u &&
              g &&
              ((f = !0),
              to(g, u, () => {
                eu();
              })),
            d || f
              ? setTimeout(() => {
                  eu();
                }, 350)
              : eu());
        }
        function eu() {
          if (m === tr.Destroyed) return;
          m = tr.Destroyed;
          let t = K();
          for (let t of (R('destroy'),
          T('sync')?.getPlugins().Autoplay?.resume(),
          T('sync')?.getPlugins().Autoscroll?.resume(),
          i instanceof HTMLDialogElement && i.close(),
          e?.getContainer()?.classList.remove('is-idle'),
          e?.destroy(),
          Object.values(w)))
            t?.destroy();
          if (
            ((w = {}),
            i?.remove(),
            (i = void 0),
            (r = void 0),
            (e = void 0),
            ta.delete(E),
            !ta.size &&
              (f(!1), document.documentElement.classList.remove(tc), T('placeFocusBack') && t && !t.closest('[inert]')))
          )
            try {
              t?.focus({ preventScroll: !0 });
            } catch (e) {}
        }
        let ed = {
          close: es,
          destroy: eu,
          getCarousel: function () {
            return e;
          },
          getContainer: function () {
            return r;
          },
          getId: function () {
            return E;
          },
          getOptions: function () {
            return p;
          },
          getPlugins: function () {
            return w;
          },
          getSlide: function () {
            return U();
          },
          getState: function () {
            return m;
          },
          init: function (t = [], n = {}) {
            (m !== tr.Init && (ed.destroy(), (m = tr.Init)), (p = g({}, tl, n)), (E = T('id') || `fancybox-${++ts}`));
            let o = ta.get(E);
            if (
              (o && o.destroy(),
              ta.set(E, ed),
              R('init'),
              (function () {
                for (let [e, t] of Object.entries({ ...td.Plugins, ...(p.plugins || {}) }))
                  if (e && !w[e] && t instanceof Function) {
                    let n = t();
                    (n.init(ed), (w[e] = n));
                  }
                R('initPlugins');
              })(),
              (function (e = []) {
                (R('initSlides', e), (x = [...e]));
              })(t),
              (function () {
                let t = T('parentEl') || document.body;
                if (
                  !(t && t instanceof HTMLElement) ||
                  !(i = c(P(T('mainTpl') || '')) || void 0) ||
                  !((r = i.querySelector('.fancybox__container')) && r instanceof HTMLElement)
                )
                  return;
                let n = T('mainClass');
                n && y(r, n);
                let o = T('mainStyle');
                if (o && l(o)) for (let [e, t] of Object.entries(o)) r.style.setProperty(e, t);
                let a = T('theme'),
                  s = 'auto' === a ? window.matchMedia('(prefers-color-scheme:light)').matches : 'light' === a;
                (r.setAttribute('theme', s ? 'light' : 'dark'),
                  i.setAttribute('id', `${E}`),
                  i.addEventListener('keydown', (e) => {
                    'Escape' === e.key && tn(e);
                  }),
                  i.addEventListener(
                    'wheel',
                    (t) => {
                      let n = t.target,
                        o = T('wheel', t);
                      n.closest('.f-thumbs') && (o = 'slide');
                      let i = 'slide' === o,
                        r = Math.max(
                          -1,
                          Math.min(
                            1,
                            [-t.deltaX || 0, -t.deltaY || 0, -t.detail || 0].reduce(function (e, t) {
                              return Math.abs(t) > Math.abs(e) ? t : e;
                            }),
                          ),
                        ),
                        l = Date.now();
                      if (S && l - S < 300) {
                        i && tn(t);
                        return;
                      }
                      ((S = l),
                        R('wheel', t, r),
                        t.defaultPrevented ||
                          ('close' === o
                            ? es(t)
                            : 'slide' === o && e && !d(n) && (tn(t), e[r > 0 ? 'prev' : 'next']())));
                    },
                    { capture: !0, passive: !1 },
                  ),
                  i.addEventListener('cancel', (e) => {
                    es(e);
                  }),
                  t.append(i),
                  1 === ta.size && (T('hideScrollbar') && f(!0), document.documentElement.classList.add(tc)),
                  i instanceof HTMLDialogElement && (T('modal') ? i.showModal() : i.show()),
                  R('initLayout'));
              })(),
              (function () {
                if (!(u = i?.querySelector('.fancybox__carousel') || void 0)) return;
                u.fancybox = ed;
                let t = g(
                  {},
                  {
                    Autoplay: {
                      autoStart: !1,
                      pauseOnHover: !1,
                      progressbarParentEl: (e) => {
                        let t = e.getContainer();
                        return t?.querySelector('.f-carousel__toolbar [data-autoplay-action]') || t;
                      },
                    },
                    Fullscreen: { el: r },
                    Toolbar: {
                      absolute: !0,
                      items: {
                        counter: {
                          tpl: '<div class="f-counter"><span data-fancybox-page></span>/<span data-fancybox-pages></span></div>',
                        },
                      },
                      display: {
                        left: ['counter'],
                        right: ['toggleFull', 'autoplay', 'fullscreen', 'thumbs', 'close'],
                      },
                    },
                    Video: { autoplay: !0 },
                    Thumbs: { minCount: 2, Carousel: { classes: { container: 'fancybox__thumbs' } } },
                    classes: {
                      container: 'fancybox__carousel',
                      viewport: 'fancybox__viewport',
                      slide: 'fancybox__slide',
                    },
                    spinnerTpl: '<div class="f-spinner" data-fancybox-close></div>',
                    dragFree: !1,
                    slidesPerPage: 1,
                    plugins: {
                      Sync: eS,
                      Arrows: ek,
                      Lazyload: eC,
                      Zoomable: eM,
                      Html: eG,
                      Video: eU,
                      Autoplay: eN,
                      Fullscreen: eQ,
                      Thumbs: eW,
                      Toolbar: ej,
                    },
                  },
                  T('Carousel') || {},
                  { slides: x, enabled: !0, initialPage: T('startIndex') || 0, l10n: T('l10n') },
                );
                (R('initCarousel', (e = eE(u, t))),
                  e.on('*', (e, t, ...n) => {
                    R(`Carousel.${t}`, e, ...n);
                  }),
                  e.on('attachSlideEl', O),
                  e.on('detachSlideEl', I),
                  e.on('contentReady', F),
                  e.on('ready', _),
                  e.on('change', k),
                  e.on('settle', $),
                  e.on('thumbs:ready', H),
                  e.on('thumbs:destroy', H),
                  e.init());
              })(),
              i && r)
            ) {
              if (T('closeExisting')) for (let [e, t] of ta.entries()) e !== E && t.close();
              (T('fadeEffect')
                ? (setTimeout(() => {
                    C();
                  }, 500),
                  y(r, 'is-revealing'))
                : C(),
                r.classList.add('is-ready'),
                (m = tr.Ready),
                R('ready'));
            }
          },
          isCurrentSlide: function (e) {
            let t = U();
            return !!e && !!t && t.index === e.index;
          },
          isTopMost: function () {
            return Y();
          },
          off: function (e, t) {
            return (
              A.has(e) &&
                A.set(
                  e,
                  A.get(e).filter((e) => e !== t),
                ),
              ed
            );
          },
          on: function (e, t) {
            return (A.set(e, [...(A.get(e) || []), t]), ed);
          },
          toggleIdle(e) {
            ((M || !0 === e) && en(), (M && !1 !== e) || er());
          },
        };
        return ed;
      })().init(e, t);
    },
    unbind: function (e, t, n) {
      if (!m()) return;
      let o = document.body,
        i = null,
        r = '[data-fancybox]';
      (e instanceof Element && (o = e),
        a(e) && a(t) ? ((i = e), (r = t)) : a(t) && a(n) ? ((i = t), (r = n)) : a(t) ? (r = t) : a(e) && (r = e),
        (function (e, t, n) {
          if (!(e && e instanceof Element) || !n) return;
          let o = td.openers.get(e) || new Map(),
            i = o.get(t) || new Map();
          (i && n && i.delete(n),
            (i.size && n) || o.delete(t),
            o.size || (td.openers.delete(e), e.removeEventListener('click', td.fromEvent)));
        })(o, i, r));
    },
  };
  ((e.Arrows = ek),
    (e.Autoplay = eN),
    (e.Carousel = eE),
    (e.CarouselSlideContentState = ey),
    (e.CarouselState = eh),
    (e.Fancybox = td),
    (e.FancyboxState = tr),
    (e.Fullscreen = eQ),
    (e.Html = eG),
    (e.Lazyload = eC),
    (e.PANZOOM_DEFAULT_POS = el),
    (e.Panzoom = ef),
    (e.PanzoomAction = ei),
    (e.PanzoomState = ea),
    (e.PanzoomZoomLevel = er),
    (e.Sync = eS),
    (e.Thumbs = eW),
    (e.Toolbar = ej),
    (e.ToolbarColumn = eH),
    (e.Video = eU),
    (e.Zoomable = eM));
});
